import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import { toast } from "react-toastify";
import loader from "../../../assets/Images/loader.gif";
// import DateTime from "react-datetime";
// import "react-datetime/css/react-datetime.css";
import { StyledEngineProvider } from "@mui/material/styles";
import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { components as RSComponents } from 'react-select'
// import moment from 'moment';

const optionDncNumber = [
    { value: "0", label: "Select Option" },
    { value: "111260001", label: "Yes" },
    { value: "111260000", label: "No" },
];
const optionLeadChannel = [
    { label: "Select Channel", value: "" },  
    { label: "Self Lead", value: "Self Lead" },
    { label: "Marketing", value: "Self Lead" },

];

const optionProductCategory = [
    { value: "", label: "Select Option" },
    { value: "AI.VIS", label: "AI.VIS" },
    { value: "BIA", label: "BIA" },
    { value: "Cloud", label: "Cloud" },
    { value: "Manage Router", label: "Manage Router" },
    { value: "Manage Wi-Fi", label: "Manage Wi-Fi" },
    { value: "Managed Firewall", label: "Managed Firewall" },
    { value: "Managed Wifi Infra", label: "Managed Wifi Infra" },
    { value: "MBB", label: "MBB" },
    { value: "MBIA", label: "MBIA" },
    { value: "SDWAN", label: "SDWAN" },
    { value: "SIP-Trunk", label: "SIP-Trunk" },
    { value: "VOIP", label: "VOIP" },
];
const optionStatusReason = [
    { value: "0", label: "Select Option" },
    { value: "111260001", label: "Closed" },
    { value: "111260000", label: "Scheduled for Appointment" },
    { value: "111260002", label: "Lead Created/Closed" },
];

const optionDisposition = [
    { value: "0", label: "Select Option" },
    { value: "569480000", label: "Busy" },
    { value: "569480001", label: "Call Back" },
    { value: "569480002", label: "Call Drop" },
    { value: "569480003", label: "Call To Sales Rep." },
    { value: "569480004", label: "Duplicate" },
    { value: "569480007", label: "Existing Customer" },
    { value: "569480008", label: "Follow Up" },
    { value: "569480009", label: "Hung Up" },
    { value: "569480010", label: "Invalid No." },
    { value: "569480011", label: "Landline Issue" },
    { value: "569480012", label: "Language Barrier" },
    { value: "569480014", label: "Lead Business" },
    { value: "569480015", label: "Lead Home" },
    { value: "569480016", label: "Location is Non RFS" },
    { value: "111260000", label: "Lost To Competition" },
    { value: "111260001", label: "No Voice" },
    { value: "111260002", label: "Not Interested" },
    { value: "111260003", label: "Not Looking For Services" },
    { value: "111260004", label: "Not Reachable" },
    { value: "111260005", label: "Nurture" },
    { value: "111260006", label: "Online Payment Done" },
    { value: "111260007", label: "Plan Expensive" },
    { value: "111260008", label: "Pre Lead Generated" },
    { value: "111260009", label: "Ringing" },
    { value: "111260010", label: "Service Related Follow up" },
    { value: "111260011", label: "Switched Off" },
    { value: "111260012", label: "Test Call" },
    { value: "111260013", label: "Using Other ISP" },
    { value: "111260014", label: "Wrong No" },
    { value: "111260015", label: "SMS Sent" },
    { value: "111260016", label: "E-Mail Sent" },
    { value: "111260017", label: "N/A" },
];
const optionCompetitorName = [
    { value: "", label: "Select Option" },
    { value: "ACT Fibernet", label: "ACT Fibernet" },
    { value: "ADTL", label: "ADTL" },
    { value: "Aircel", label: "Aircel" },
    { value: "Airtel", label: "Airtel" },
    { value: "BSNL", label: "BSNL" },
    { value: "Hathway", label: "Hathway" },
    { value: "Jio", label: "Jio" },
    { value: "MTNL", label: "MTNL" },
    { value: "N.A", label: "N.A" },
    { value: "new com", label: "new com" },
    { value: "Nextra", label: "Nextra" },
    { value: "Others", label: "Others" },
    { value: "Reliance Communications", label: "Reliance Communications" },
    { value: "Sify", label: "Sify" },
    { value: "Tata Communications", label: "Tata Communications" },
    { value: "Tata DOCOMO", label: "Tata DOCOMO" },
    { value: "Tikona Infinet", label: "Tikona Infinet" },
    { value: "Vodafone", label: "Vodafone" },
];
const optionIndustrySegment = [
    // { value: "Others", label: "Others" },
    { value: "PG", label: "PG" },
];
const optionState = [
    { name: "Select State", code: "" },
    { name: "Andhra Pradesh", code: "100009" },
    { name: "Jharkhand", code: "100030" },
    { name: "Bihar", code: "100021" },
    { name: "Delhi", code: "100004" },
    { name: "Gujarat", code: "100015" },
    { name: "Haryana", code: "100008" },
    { name: "Jammu and Kashmir", code: "100011" },
    { name: "Karnataka", code: "100007" },
    { name: "Kerala", code: "100012" },
    { name: "Madhya Pradesh", code: "100014" },
    { name: "Maharashtra", code: "100002" },
    { name: "Odisha", code: "100026" },
    { name: "Other*", code: "100017" },
    { name: "Punjab", code: "100025" },
    { name: "Rajasthan", code: "100010" },
    { name: "Tamil Nadu", code: "100003" },
    { name: "Telangana", code: "100023" },
    { name: "Uttar Pradesh", code: "100006" },
    { name: "Uttarakhand", code: "100016" },
    { name: "West Bengal", code: "100013" },
    { name: "Goa", code: "100028" },
];

const optionPgWifiBill = [
    { value: "", label: "Select Option" },
    { value: "Less than 10000", label: "Less than 10000" },
    { value: "10000 to 15000", label: "10000 to 15000" },
    { value: "15000 to 20000", label: "15000 to 20000" },
    { value: "20000 to 25000", label: "20000 to 25000" },
    { value: "More than 25000", label: "More than 25000" },
];
const optionPgCamera = [
    { value: "", label: "Select Option" },
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
];
const optionPgCategory = [
    { value: "", label: "Select Option" },
    { value: "Boys PG", label: "Boys PG" },
    { value: "Girls PG", label: "Girls PG" },
    { value: "Service Apartment", label: "Service Apartment" },
    { value: "Co-Living", label: "Co-Living" },
];
const optionPgSolution = [
    { value: "", label: "Select Option" },
    { value: "Hot Lead", label: "Hot Lead" },
    { value: "Warm Lead", label: "Warm Lead" },
    { value: "Cold Lead", label: "Cold Lead" },
    { value: "Not Interested", label: "Not Interested" },
];

const BusinessPgContactForm = () => {
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
        inputFocused: {
            boxShadow: "none",
            fontSize: "14px",
        },
    };
    const optionQualify = [
        { value: '111260018', label: 'Non-ICP: Rooms' },
        { value: '111260019', label: 'Non-ICP: Rent' },
        { value: '111260020', label: 'Non-ICP: Ownership' },
        { value: '111260021', label: 'Non - RFS' },
        { value: '111260022', label: 'Incorrect Address: No PG-alike building found' },
        { value: '111260023', label: 'Property Non-Operational' },
        { value: '111260024', label: 'Customer Unresponsive / Not Reachable' },
    ];

    const remarkTemplate = `Connectivity Type (BB / ILL / ILL + BB / ILL + ILL) : 
# BB Links (Count (Enter 0 if not used)) :
Aggregate BB Bandwidth (Mbps) (Number (Enter 0 if not used)) :
BB Service Provider Name(s) (Name 1, Name 2) :
# ILL Links (Count (Enter 0 if not used)) :
Aggregate ILL Bandwidth (Mbps) (Number (Enter 0 if not used)) :
ILL Service Provider Name(s) (Name 1, Name 2) :
Current Distribution Infra (Wi-Fi / LAN) :
Wi-Fi Infra (AP-Own / AP-Vendor / AP-ISP, Router-Extender-Mesh) :
Current Static IP Setup (Yes / No) :
Static IP Count (Number of IPs if Yes above) :
Current Spend (INR per month) : 
Expansion/Relocation Plans (Text) :
Clear Pain Felt: (Yes / No / Can't Say) :
Description of Pain: (Text) :
------------------------------------------------------------------------------------------
`;

    const [activeForm, setActiveForm] = useState("form1");
    const [userData, setUserData] = useState({
        fullName: "",
        firstName: "",
        lastName: "",
        mobileOne: "",
        mobileTwo: "",
        email: "",
        campaignName: "",
        otp: "",
        specificBuilding: "",
        specificArea: "",
        // remark: "",
        remarkHistory: "",  // store all old remarks
        newRemark: remarkTemplate,
        pgOwner: "",
        pgContactNum: "",
        howManyPg: "",
        pgAddress: "",
        pgAreaName: "",
        NumOfPgFloor: "",
        NumOfPgRoom: "",
        NumOfPgBed: "",
        currentWifiOperator: "",
        NumOfPgBroadband: "",
        dateOfRecharge: "",
        serviceExpect: "",
        changeReason: "",
        pgName: "",
        pgType: "",             // Will be updated by handleSelectPGType
        tenantType: "",         // Will be updated by handleSelectTenantType
        spectraRFS: "",
        contactDesignation: "", // Will be updated by handleSelectContactDesignation
        numberOfRooms: "",
        numberOfBeds: "",
        perBedRent: "",
        googleRatings: "",
        pgInternetRatings: "",
        existingInternetProvider: "",
        existingInternetOutflow: "",
        currentInfra: "",
        painPoints: [], // multi-select: store as an array
        urgentTriggers: "",
        spectraRelationship: "",
        role: "",
        latitude: "",
        longitude: "",
        designation: "",
        contactPerson2Name: "",
        contactPerson2Designation: "",
        contactPerson2Mobile: "",
        contactPerson2Email: "",
        contactPerson2Role: "",
        contactPerson3Name: "",
        contactPerson3Designation: "",
        contactPerson3Mobile: "",
        contactPerson3Email: "",
        contactPerson3Role: "",
        buildingNoPlotNo: "",
        block: "",
        floor: "",
        street: "",
        locality: "",
        landmarkIfAny: "",
        pinCode: "",
    });
    const optionBuildingType = [
        { label: "Single Tenant", value: "1" },
        { label: "Multi Tenant", value: "2" },
    ];
    const [selectBuildingType, setSelectBuildingType] = useState('');

    const handleSelectBuildingType = (selectBuildingType) => {
        setSelectBuildingType(selectBuildingType);
    };
    const roleOptions = [
        { value: "111260000", label: "KDM" },
        { value: "111260001", label: "Influencer" },
    ];

    const designationOptions = [
        { value: "111260000", label: "Owner" },
        { value: "111260001", label: "Manager" },
        { value: "111260002", label: "CareTaker" },
        { value: "111260003", label: "Other" },
    ];
    // Options for PG Type
    const pgTypeOptions = [
        { value: "111260000", label: "Men" },
        { value: "111260001", label: "Women" },
        { value: "111260002", label: "Hybrid" },
    ];

    // Options for Tenant Type
    const tenantTypeOptions = [
        { value: "111260000", label: "Professional" },
        { value: "111260001", label: "Student" },
    ];

    // Options for Existing Internet Provider
    const existingInternetProviderOptions = [
        { value: "111260000", label: "Airtel" },
        { value: "111260001", label: "Jio" },
        { value: "111260002", label: "Tata" },
        { value: "111260003", label: "ACT" },
        { value: "111260004", label: "New Building" },
        { value: "111260005", label: "Others" },
    ];

    // Options for Existing Internet Outflow Per Month
    const existingInternetOutflowOptions = [
        { value: "111260000", label: "<5000" },
        { value: "111260001", label: "5001 - 10000" },
        { value: "111260002", label: "10001 - 15000" },
        { value: "111260003", label: "15001 - 20000" },
        { value: "111260004", label: "20001 - 25000" },
        { value: "111260005", label: ">25000" },
        { value: "111260006", label: "New Building" },
        { value: "111260007", label: "Others" },
    ];

    // Options for Current Infra
    const currentInfraOptions = [
        { value: "111260000", label: "Broadband" },
        { value: "111260001", label: "Access Points" },
        { value: "111260002", label: "Others" },
    ];

    // Options for Pain Points (for multi-select)
    const painPointsOptions = [
        { value: "poorCustomerReviews", label: "Poor Customer Reviews" },
        { value: "tenantComplaints", label: "Tenant Complaints" },
        { value: "tenantChurn", label: "Tenant Churn" },
        { value: "poorCustomerSupport", label: "Poor Customer Support from existing vendor" },
        { value: "multipleVendors", label: "Multiple Vendors" },
        { value: "newBuilding", label: "New Building" },
    ];

    // Options for Urgent Triggers
    const urgentTriggersOptions = [
        { value: "111260000", label: "New semester" },
        { value: "111260001", label: "Tenant move-ins" },
        { value: "111260002", label: "Infrastructure Upgrades" },
        { value: "111260003", label: "Expiry of Existing Service Provider" },
        { value: "111260004", label: "New Building" },
    ];

    // Options for Spectra Relationship
    const spectraRelationshipOptions = [
        { value: "111260000", label: "Existing User" },
        { value: "111260001", label: "Past User" },
        { value: "111260002", label: "New" },
    ];

    const [selectPGType, setSelectPGType] = useState(null);
    const [selectTenantType, setSelectTenantType] = useState(null);
    const [selectContactDesignation, setSelectContactDesignation] = useState(null);
    const handleEmailBlur = (e) => {
        const email = e.target.value;
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

        if (email && !emailRegex.test(email)) {
            toast.error("Invalid email address", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        }
    };
    // Handler for PG Type drop-down
    const handleSelectPGType = (selectedOption) => {
        setSelectPGType(selectedOption);
        setUserData({
            ...userData,
            pgType: selectedOption ? selectedOption.value : "",
        });
    };

    // Handler for Tenant Type drop-down
    const handleSelectTenantType = (selectedOption) => {
        setSelectTenantType(selectedOption);
        setUserData({
            ...userData,
            tenantType: selectedOption ? selectedOption.value : "",
        });
    };

    // Handler for Contact Designation drop-down
    const handleSelectContactDesignation = (selectedOption) => {
        setSelectContactDesignation(selectedOption);
        setUserData({
            ...userData,
            contactDesignation: selectedOption ? selectedOption.value : "",
        });
    };
    const [isLoading, setIsLoading] = useState(false);
    const [selectDNCno, setSelectDNCno] = useState(optionDncNumber[0]);
    const [selectLeadChannel, setSelectLeadChannel] = useState(
        optionLeadChannel[0]
    );
    const [selectLeadSource, setSelectLeadSource] = useState();
    const [leadSourceOptions, setLeadSourceOptions] = useState([]);
    const [selectProductCategory, setSelectProductCategory] = useState(
        optionProductCategory[0]
    );
    const [selectStatusReason, setSelectStatusReason] = useState(
        optionStatusReason[0]
    );
    const [checkStatusReason, setCheckStatusReason] = useState("");
    const [selectDisposition, setSelectDisposition] = useState(
        optionDisposition[0]
    );
    const [selectCompetitorName, setSelectCompetitorName] = useState(
        optionCompetitorName[0]
    );
    const [selectIndustrySegment, setSelectIndustrySegment] = useState(
        optionIndustrySegment[0]
    );
    const [selectCity, setSelectCity] = useState("");
    const [cityType, setCityType] = useState([]);
    const [selectState, setSelectState] = useState("");
    const [areaList, setAreaList] = useState([]);
    const [selectArea, setSelectArea] = useState("");
    const [buildingList, setBuildingList] = useState([]);
    const [selectBuilding, setSelectBuilding] = useState("");
    const [selectPgCategory, setSelectPgCategory] = useState(optionPgCategory[0]);
    const [selectPgWifiBill, setSelectPgWifiBill] = useState(optionPgWifiBill[0]);
    const [selectPgCamera, setSelectPgCamera] = useState(optionPgCamera[0]);
    const [selectPgSolution, setSelectPgSolution] = useState(optionPgSolution[0]);
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState("");
    const [fieldsEditable, setFieldsEditable] = useState(true);
    const [otpContactStatus, setOtpContactStatus] = useState("");
    const [selectedDateTime, setSelectedDateTime] = useState(null);
    // const [cityCode , setCityCode]=useState("");
    // const [cityName , setCityName]=useState("");
    // For Contact Person 2 dropdowns
    const [selectContact2Designation, setSelectContact2Designation] = useState(null);
    const [selectContact2Role, setSelectContact2Role] = useState(null);

    // For Contact Person 3 dropdowns
    const [selectContact3Designation, setSelectContact3Designation] = useState(null);
    const [selectContact3Role, setSelectContact3Role] = useState(null);
    const [meetingcounter, setmeetingcounter] = useState("");

    const [mrafieldone, setmrafieldone] = useState("");

    const [mrafieldtwo, setmrafieldtwo] = useState("");

    // Generic change handler for text/number inputs


    // Handler for Contact Person 2 Designation dropdown
    const handleSelectContact2Designation = (selectedOption) => {
        setSelectContact2Designation(selectedOption);
        setUserData((prevData) => ({
            ...prevData,
            contactPerson2Designation: selectedOption ? selectedOption.value : "",
        }));
    };

    // Handler for Contact Person 2 Role dropdown
    const handleSelectContact2Role = (selectedOption) => {
        setSelectContact2Role(selectedOption);
        setUserData((prevData) => ({
            ...prevData,
            contactPerson2Role: selectedOption ? selectedOption.value : "",
        }));
    };

    // Handler for Contact Person 3 Designation dropdown
    const handleSelectContact3Designation = (selectedOption) => {
        setSelectContact3Designation(selectedOption);
        setUserData((prevData) => ({
            ...prevData,
            contactPerson3Designation: selectedOption ? selectedOption.value : "",
        }));
    };

    // Handler for Contact Person 3 Role dropdown
    const handleSelectContact3Role = (selectedOption) => {
        setSelectContact3Role(selectedOption);
        setUserData((prevData) => ({
            ...prevData,
            contactPerson3Role: selectedOption ? selectedOption.value : "",
        }));
    };

    const handleChange = (e) => {

        // console.log(e.target.name);
        // console.log(e.target.value);
        setUserData({ ...userData, [e.target.name]: e.target.value });
    };

    const handleChange1 = (e) => {

        // console.log(e.target.name);
        // console.log(e.target.value);
        setUserData({ ...userData, [e.target.name]: isNaN(parseInt(e.target.value, 10)) ? "" : parseInt(e.target.value, 10) });
    };


    const [showForm, setShowForm] = useState(false)

    const [selectedReasons, setSelectedReasons] = useState([])

    const MultiValueRemove = (props) => (
        <RSComponents.MultiValueRemove {...props}>
            <span style={{ color: '#900', fontSize: '16px', lineHeight: '1' }}>×</span>
        </RSComponents.MultiValueRemove>
    )


    const handleChanged = (options) => {
        setSelectedReasons(options || [])
    }

    const handleDisqualify = async () => {
        if (!selectedReasons.length) {
            toast.warning('Please pick at least one reason.')
            return
        }

        const reasonList = selectedReasons.map(o => o.label).join(', ')
        const apiUrl = process.env.REACT_APP_API_URL;
        const payload = {
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            Action: 'contactDisqualify',           // ← your new API action
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password'),
            ContactID: ContactId,                   // fixed key name
            ReasonForDisqualify: reasonList
        }

        try {
            const res = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            })
            const data = await res.json()

            if (data.StatusCode === '200' || data.Response?.StatusCode === 200) {
                toast.success('Contact disqualified successfully!', {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                })
                navigate('/businessContactPg')
            } else {
                toast.error(data.Response?.Message || data.Message || 'Failed to disqualify')
            }
        } catch (err) {
            console.error(err)
            toast.error('Network error, please try again.')
        }
    };



    const handleBlur = (e) => {
        console.error("Error fetching data:", "error");
        const { name, value } = e.target;
        if (name === "numberOfRooms") {
            const numValue = Number(value);
            if (numValue < 30) {
                // Correct the value to 50 when the user leaves the input
                setUserData({
                    ...userData,
                    [name]: "",

                });
                toast.warning("Please Enter the value more than 30", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        }
        if (name === "numberOfBeds") {
            const numValue = Number(value);
            if (numValue < 100) {
                // Correct the value to 50 when the user leaves the input
                setUserData({
                    ...userData,
                    [name]: "",

                });
                toast.warning("Please Enter the value more than 100", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        }
        if (name === "perBedRent") {
            const numValue = Number(value);
            if (numValue < 10000) {
                // Correct the value to 50 when the user leaves the input
                setUserData({
                    ...userData,
                    [name]: "",

                });
                toast.warning("Please Enter the value more than 10000", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        }
    };
    const handleSelectDNC = (selectDNC) => {
        setSelectDNCno(selectDNC);
    };
    const handleSelectLead = (selectLead) => {
        setSelectLeadChannel(selectLead);
    };
    const handleSelectLeadSource = (selectLeadSource) => {
        setSelectLeadSource(selectLeadSource);
    };
    const handleSelectProductCategory = (selectProductCategory) => {
        setSelectProductCategory(selectProductCategory);
    };
    const handleSelectStatusReason = (selectStatusReason) => {
        setSelectStatusReason(selectStatusReason);
    };
    const handleSelectDisposition = (selectDisposition) => {
        setSelectDisposition(selectDisposition);
    };
    const handleSelectCompetitorName = (selectCompetitorName) => {
        setSelectCompetitorName(selectCompetitorName);
    };
    const handleSelectIndustrySegment = (selectIndustrySegment) => {
        setSelectIndustrySegment(selectIndustrySegment);
        getLocation();

    };
    const handleSelectPgCategory = (selectPgCategory) => {
        setSelectPgCategory(selectPgCategory);
    };
    const handleSelectWifiBill = (selectWifiBill) => {
        setSelectPgWifiBill(selectWifiBill);
    };
    const handleSelectPgCamera = (selectPgCamera) => {
        setSelectPgCamera(selectPgCamera);
    };
    const handleSelectPgSolution = (selectPgSolution) => {
        setSelectPgSolution(selectPgSolution);
    };
    const [selectExistingInternetProvider, setSelectExistingInternetProvider] = useState(null);
    const handleSelectExistingInternetProvider = (selectedOption) => {
        setSelectExistingInternetProvider(selectedOption);
        setUserData((prev) => ({
            ...prev,
            existingInternetProvider: selectedOption ? selectedOption.value : "",
        }));
    };

    // Existing Internet Outflow Per Month
    const [selectExistingInternetOutflow, setSelectExistingInternetOutflow] = useState(null);
    const handleSelectExistingInternetOutflow = (selectedOption) => {
        setSelectExistingInternetOutflow(selectedOption);
        setUserData((prev) => ({
            ...prev,
            existingInternetOutflow: selectedOption ? selectedOption.value : "",
        }));
    };

    // Current Infra (using placeholder options; update as needed)
    const [selectCurrentInfra, setSelectCurrentInfra] = useState(null);
    const handleSelectCurrentInfra = (selectedOption) => {
        setSelectCurrentInfra(selectedOption);
        setUserData((prev) => ({
            ...prev,
            currentInfra: selectedOption ? selectedOption.value : "",
        }));
    };

    // Pain Points (multi-select)
    const [selectPainPoints, setSelectPainPoints] = useState([]);
    const handleSelectPainPoints = (selectedOptions) => {
        setSelectPainPoints(selectedOptions);
        setUserData((prev) => ({
            ...prev,
            painPoints: selectedOptions ? selectedOptions.map((option) => option.value) : [],
        }));
    };

    // Urgent Triggers
    const [selectUrgentTriggers, setSelectUrgentTriggers] = useState(null);
    const handleSelectUrgentTriggers = (selectedOption) => {
        setSelectUrgentTriggers(selectedOption);
        setUserData((prev) => ({
            ...prev,
            urgentTriggers: selectedOption ? selectedOption.value : "",
        }));
    };

    // Spectra Relationship
    const [selectSpectraRelationship, setSelectSpectraRelationship] = useState(null);
    const handleSelectSpectraRelationship = (selectedOption) => {
        setSelectSpectraRelationship(selectedOption);
        setUserData((prev) => ({
            ...prev,
            spectraRelationship: selectedOption ? selectedOption.value : "",
        }));
    };

    // Role
    const [selectRole, setSelectRole] = useState(null);
    const handleSelectRole = (selectedOption) => {
        setSelectRole(selectedOption);
        setUserData((prev) => ({
            ...prev,
            role: selectedOption ? selectedOption.value : "",
        }));
        getLocation();

    };
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            // backgroundColor: "black",
            color: "white",
            // border: "none",
            boxShadow: state.isFocused ? "none" : provided.boxShadow,
            textAlign: "center",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "white",
        }),
        option: (provided, state) => ({
            ...provided,
            // backgroundColor: state.isFocused ? 'blue' : 'black',
            color: "black",
            textAlign: "center",
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#f0f0f0',
            borderRadius: '4px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#333',
        }),
    };


    // Handler for qualifying (button click)
    const handleQualify = async () => {
        if (!userData.pgName || userData.pgName.trim() === "") {
            toast.error("Name of PG cannot be empty", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }
        if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userData.email)
        ) {
            toast.warning("Please Enter Email Address", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 500,
            });
            return;

        }


        // Validate select fields
        if (!selectPGType) {
            toast.error("PG Type must be selected", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }
        if (!selectTenantType) {
            toast.error("Tenant Type must be selected", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }

        // Validate numeric fields
        if (!userData.numberOfRooms || Number(userData.numberOfRooms) < 30) {
            toast.error("Number of Rooms must be at least 30", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }
        // if (!userData.numberOfBeds || Number(userData.numberOfBeds) < 100) {
        //     toast.error("Number of Beds must be at least 100", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        //     return;
        // }
        if (!userData.perBedRent || Number(userData.perBedRent) < 10000) {
            toast.error("Per Bed Rent must be at least 10000", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }

        // If ContactId exists, validate additional fields
        if (ContactId) {
            if (!selectExistingInternetProvider) {
                toast.error("Existing Internet Provider must be selected", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return;
            }

            if (!selectExistingInternetOutflow) {
                toast.error("Existing Internet Outflow must be selected", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return;
            }

            if (!selectPainPoints || selectPainPoints.length === 0) {
                toast.error("Please select at least one Pain Point", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return;
            }
            if (!selectSpectraRelationship) {
                toast.error("Spectra Relationship must be selected", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return;
            }

        }

        try {
            setIsLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const qualifyData = {
                Action: "contactQualifyDisqualify",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                CantactID: ContactId,
                CantactStatus: "Yes", // For qualifying
                password: sessionStorage.getItem("password"),
                ReasonForDisqualify: "", // No reason needed when qualifying
                userName: sessionStorage.getItem("userName"),
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(qualifyData),
            });
            const data = await response.json();

            if (data.Response.StatusCode === 200) {
                toast.success("Contact Qualified Successfully", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                navigate("/businessLeadPg");
            } else {
                toast.warning(data.Response.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        } catch (error) {
            console.error("Error during API call:", error);
        } finally {
            setIsLoading(false);
        }
    };





    const handleSelectCity = async (selectedOption) => {
        const selectedCityCode = selectedOption ? selectedOption.value : "";
        const selectedCityName = selectedOption ? selectedOption.label : "";
        // console.log("selectedCityCode", selectedOption.value);
        // console.log("selectedCityName", selectedOption.label);
        setSelectCity(selectedOption);
        try {
            const areaApiUrl = process.env.REACT_APP_API_URL;
            const areaRequestBody = {
                Action: "getArea",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                cityCode: selectedCityCode,
                cityName: selectedCityName,
                password: sessionStorage.getItem("password"),
                restrictedarea: false,
                stateCode: "",
                userName: sessionStorage.getItem("userName"),
            };
            const areaResponse = await fetch(areaApiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(areaRequestBody),
            });
            const areaData = await areaResponse.json();
            if (areaData.Response && Array.isArray(areaData.Response.Data)) {
                // console.log("area :", areaData.Response.Data);
                setAreaList(areaData.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching area data:", error);
        }
    };

    const handleSelectState = (selectedState) => {
        setSelectState(selectedState);
    };

    const [position, setPosition] = useState({ latitude: null, longitude: null });

    // const getLocation = () => {
    //     if ("geolocation" in navigator) {
    //         navigator.geolocation.getCurrentPosition(function (position) {
    //             setPosition({
    //                 latitude: position.coords.latitude,
    //                 longitude: position.coords.longitude,
    //                 message: "Location Captured",
    //             });
    //         });
    //     } else {
    //         // console.log("Geolocation is not available in your browser.");
    //         toast.warning("location is not available in your browser.", {
    //             position: toast.POSITION.BOTTOM_CENTER,
    //             autoClose: 1500,
    //         });
    //     }
    //     console.log("area :", position)
    // };

    const getLocation = () => {
        // Check if served over HTTPS (geolocation doesn't work over HTTP in production)
        if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
            toast.error("Location access requires HTTPS. Please use a secure connection.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 2000,
            });
            return;
        }

        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    setPosition({
                        latitude: pos.coords.latitude,
                        longitude: pos.coords.longitude,
                        message: "Location Captured",
                    });
                },
                (error) => {
                    console.error("Geolocation error:", error);
                    toast.error("Unable to retrieve location. Please check browser permissions.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                }
            );
        } else {
            toast.warning("Geolocation is not supported by this browser.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 2000,
            });
        }
    };

    // Log updated location when it changes
    useEffect(() => {
        if (position.latitude && position.longitude) {
            console.log("Updated position:", position);
        }
    }, [position]);


    useEffect(() => {
        getLocation();
    }, []);

    useEffect(() => {

        const fetchCities = async () => {
            try {
                // City API call
                const cityApiUrl = process.env.REACT_APP_API_URL;
                const cityRequestBody = {
                    Action: "getCity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    password: sessionStorage.getItem("password"),
                    stateCode: selectState.value,
                    userName: sessionStorage.getItem("userName"),
                };
                const cityResponse = await fetch(cityApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(cityRequestBody),
                });
                const cityData = await cityResponse.json();

                if (cityData.Response && Array.isArray(cityData.Response.Data)) {
                    const filteredCities = cityData.Response.Data.filter(
                        (city) => city.IsOperationalCity === true
                    );
                    setCityType(filteredCities);
                } else {
                    // console.error("City data structure not recognized:",cityData.Response);
                    setCityType([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        // fetchCities();
        // Fetch cities only if a state is selected
        if (selectState) {
            fetchCities();
        }
    }, [selectState]);



    const handleSelectArea = async (selectedOption) => {
        setSelectArea(selectedOption);
        const areaCode = selectedOption.value;
        const areaName = selectedOption.label.split(" ")[0];
        try {
            const buildingApiUrl = process.env.REACT_APP_API_URL;
            const buildingRequestBody = {
                Action: "getBuilding",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                areaCode: areaCode,
                areaName: areaName,
                password: sessionStorage.getItem("password"),
                userName: sessionStorage.getItem("userName"),
            };

            const buildingResponse = await fetch(buildingApiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(buildingRequestBody),
            });
            const buildingData = await buildingResponse.json();
            if (buildingData.Response && Array.isArray(buildingData.Response.Data)) {
                setBuildingList(buildingData.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching building data:", error);
        }
    };

    const handleSendOtp = async (email, mobileNo) => {
        // console.log("Button clicked");
        if (!userData.mobileOne) {
            toast.warning("Please Enter Customer Contact Number", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userData.email)
        ) {
            toast.warning("Please Enter Customer Email Id", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else {
            try {
                setIsLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const otpRequestBody = {
                    Action: "sendOTPContact",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    mobileNo: mobileNo,
                    preOTP: "",
                    userEmail: email,
                };
                const otpResponse = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(otpRequestBody),
                });
                const sendOtpData = await otpResponse.json();
                // console.log("send otp :",sendOtpData)
                if (sendOtpData.Status === "Success") {
                    // console.log("send otp :",sendOtpData.Status)
                    toast.success("OTP Send Successfully", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setOtpSent(true);
                    setOtp(sendOtpData.Response);
                    setIsLoading(false);
                    // console.log("sendOtpData.Response :", sendOtpData.Response);
                } else {
                    // console.error('Failed to send OTP:', otpResponse.statusText);
                    toast.warning(otpResponse.statusText, {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("Error sending OTP:", error);
            }
        }
    };

    const handleVerifyOtp = () => {
        const otpValue = String(otp).trim();
        const customerOtpValue = userData.otp.trim();
        // console.log("userData.otp :",customerData.otp);
        // console.log("otp :",otp);
        setIsLoading(true);
        if (otpValue === customerOtpValue) {
            toast.success("OTP verified Successfully", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            setOtpContactStatus("111260000");
            setFieldsEditable(false);
            setIsLoading(false);
        } else {
            toast.warning("Incorrect OTP", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            setOtpContactStatus("111260001");
            setIsLoading(false);
        }
    };

    const handleResendOtp = async (email, mobileNo) => {
        const otpValue = String(otp).trim();
        try {
            setIsLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const otpRequestBody = {
                Action: "sendOTPContact",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                mobileNo: mobileNo,
                preOTP: otpValue,
                userEmail: email,
            };
            const otpResponse = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(otpRequestBody),
            });
            const resendOtpData = await otpResponse.json();
            // console.log("resend otp :", resendOtpData);
            if (resendOtpData.Status === "Success") {
                // console.log("send otp :",resendOtpData.Status)
                toast.success("OTP Resend Successfully", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                setIsLoading(false);
                // setFieldsEditable(false);
                // setOtpSent(true);
                // setOtp(sendOtpData.Response);
                // console.log("sendOtpData.Response :",sendOtpData.Response)
            } else {
                toast.warning(otpResponse.statusText || "Failed to send OTP", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                setIsLoading(false);
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
        }
    };

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const ContactId = searchParams.get("ContactId");
    // console.log("ContactId :", ContactId);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // lead source API call
                const leadSourceApiUrl = process.env.REACT_APP_API_URL;
                const leadSourceRequestBody = {
                    Action: "getSource",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    channelName: selectLeadChannel.value,
                    password: sessionStorage.getItem("password"),
                    userName: sessionStorage.getItem("userName"),
                };
                const leadSourceResponse = await fetch(leadSourceApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(leadSourceRequestBody),
                });
                const leadSourceData = await leadSourceResponse.json();
                // console.log("lead Source :", leadSourceData.Response.Data);
                // Check if data is not undefined or null before mapping
                if (leadSourceData.Response.Data) {
                    // Transforming data into the required format
                    const transformedOptions = leadSourceData.Response.Data.map(
                        (option) => ({
                            label: option.SourceName,
                            value: option.SourceName,
                        })
                    );
                    // console.log("setLeadSourceOptions",transformedOptions)
                    setLeadSourceOptions(transformedOptions);
                    if (!ContactId && transformedOptions.length > 0) {
                        setSelectLeadSource(transformedOptions[0]);
                    }
                } else {
                    // If data is undefined or null, set leadSourceOptions to an empty array
                    setLeadSourceOptions([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [selectLeadChannel, ContactId]);

    // Get the current date and time
    const currentDate = new Date();
    // Extract individual components
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1; // Note: Months are zero-based (0-January, 1-February, etc.)
    const date = currentDate.getDate();
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    const seconds = currentDate.getSeconds();
    // Format the date and time as a string
    const formattedDateTime = `${year}-${month < 10 ? "0" + month : month}-${date < 10 ? "0" + date : date
        } ${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes
        }:${seconds < 10 ? "0" + seconds : seconds}`;
    // console.log("Current Date and Time:", formattedDateTime);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getContactIndustry",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    contactID: ContactId,

                    password: sessionStorage.getItem("password"),
                    userName: sessionStorage.getItem("userName"),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });
                const data = await response.json();
                // const data = await response.json();
                const apiData = data.Response.Data[0];

                // console.log("getContact", data);
                // console.log("FollowupDate :", data.Response.Data[0].NumberofRooms)
                setUserData({
                    fullName: data.Response.Data[0].FullName,
                    firstName: data.Response.Data[0].FirstName,
                    lastName: data.Response.Data[0].LastName,
                    mobileOne: data.Response.Data[0].MobileNumber,
                    mobileTwo: data.Response.Data[0].MobileNumber2,
                    email: data.Response.Data[0].EmailAddress,
                    campaignName: data.Response.Data[0].CampaignName,
                    specificBuilding: data.Response.Data[0].Specifybuilding,
                    specificArea: data.Response.Data[0].SpecifyArea,
                    // remark: data.Response.Data[0].Remark,
                     remarkHistory: data.Response.Data[0].Remark || "",
                    pgName: data.Response.Data[0].PGName,
                    spectraRFS: data.Response.Data[0].SpectraRFS,
                    designationOthers: data.Response.Data[0].DesignationOthers,
                    numberOfRooms: data.Response.Data[0].NumberofRooms,
                    numberOfBeds: data.Response.Data[0].NumberofBeds,
                    perBedRent: data.Response.Data[0].PerBedRent,
                    existingInternetProviderOther: data.Response.Data[0].ExistingInternetProviderOther,
                    existingInternetOutflowPerMonthOther: data.Response.Data[0].ExistingInternetOutflowPerMonthOther,
                    currentInfraOther: data.Response.Data[0].CurrentInfraOther,
                    googleRatings: data.Response.Data[0].GoogleRatings,
                    pgInternetRatings: data.Response.Data[0].PGInternetRatings,
                    contactPerson2Name: apiData.ContactPerson2,
                    contactPerson2Email: apiData.EmailID2,
                    contactPerson2Mobile: apiData.MobileNumber2, // Make sure your API field is correct
                    designationOthers2: apiData.DesignationOthers2, // Extra info if needed
                    contactPerson2Designation: apiData.Designation2, // For dropdown
                    contactPerson2Role: apiData.Role2,              // For dropdown
                    // Contact Person 3 details
                    contactPerson3Name: apiData.ContactPerson3,
                    contactPerson3Email: apiData.EmailID3,
                    contactPerson3Mobile: apiData.MobileNumber3,
                    designationOthers3: apiData.DesignationOthers3, // Extra info if needed
                    contactPerson3Designation: apiData.Designation3, // For dropdown
                    contactPerson3Role: apiData.Role3,
                    pgType: apiData.PGType,
                    tenantType: apiData.TenantType,
                    existingInternetProvider: apiData.ExistingInternetProvider,
                    existingInternetOutflow: apiData.ExistingInternetOutflowPerMonth,
                    currentInfra: apiData.CurrentInfra,
                    urgentTriggers: apiData.UrgentTriggers,
                    spectraRelationship: apiData.SpectraRelationship,
                    role: apiData.Role,
                    designation: apiData.Designation,
                    contactDesignation: apiData.Designation,
                    latitude: apiData.Latitude,
                    longitude: apiData.Longitude,
                    NoOfRoomsAsPerMRA: apiData.NoOfRoomsAsPerMRA,
                    PerbedrentAsPerMRA: apiData.PerbedrentAsPerMRA,
                    buildingNoPlotNo: apiData.BuildingNoPlotNo,
                    block: apiData.Block,
                    floor: apiData.Floor,
                    street: apiData.Street,
                    locality: apiData.Locality,
                    landmarkIfAny: apiData.LandmarkIfAny,
                    pinCode: apiData.PinCode,

                    // For pain points, create an array based on boolean "1" values
                    painPoints: [
                        apiData.PoorCustomerReviews === "1" && "poorCustomerReviews",
                        apiData.TenantComplaints === "1" && "tenantComplaints",
                        apiData.TenantChurn === "1" && "tenantChurn",
                        apiData.PoorCustomerSupportfromexistingvendor === "1" && "poorCustomerSupport",
                        apiData.MultipleVendors === "1" && "multipleVendors",
                        apiData.NewBuilding === "1" && "newBuilding",
                    ].filter(Boolean),
                });
                setSelectBuildingType(optionBuildingType.find(option => option.value === apiData.BuildingType))
                setmrafieldone(apiData.NoOfRoomsAsPerMRA);
                setmrafieldtwo(apiData.PerbedrentAsPerMRA);
                setmeetingcounter(apiData.MeetingCounter);
                setSelectContact2Designation(
                    designationOptions.find(option => option.value === apiData.Designation2)
                );
                setSelectContact2Role(
                    roleOptions.find(option => option.value === apiData.Role2)
                );

                // *** Populate Contact Person 3 Dropdowns ***
                setSelectContact3Designation(
                    designationOptions.find(option => option.value === apiData.Designation3)
                );
                setSelectContact3Role(
                    roleOptions.find(option => option.value === apiData.Role3)
                );

                // const roleData = data.Response.Data[0].Role;
                // const designationData = data.Response.Data[0].Designation;


                // PG Type
                setSelectPGType(
                    pgTypeOptions.find(option => option.value === data.Response.Data[0].PGType)
                );

                // Tenant Type
                setSelectTenantType(
                    tenantTypeOptions.find(option => option.value === data.Response.Data[0].TenantType)
                );

                // Existing Internet Provider
                setSelectExistingInternetProvider(
                    existingInternetProviderOptions.find(
                        option => option.value === data.Response.Data[0].ExistingInternetProvider
                    )
                );

                // Existing Internet Outflow Per Month
                setSelectExistingInternetOutflow(
                    existingInternetOutflowOptions.find(
                        option => option.value === data.Response.Data[0].ExistingInternetOutflowPerMonth
                    )
                );

                // Current Infra
                setSelectCurrentInfra(
                    currentInfraOptions.find(option => option.value === data.Response.Data[0].CurrentInfra)
                );

                // Extract the pain points data from the response
                const painPointsResponse = data.Response.Data[0];

                // Build an array of selected pain point values based on the API response
                const selectedPainPoints = [];

                if (painPointsResponse.PoorCustomerReviews === "1") {
                    selectedPainPoints.push("poorCustomerReviews");
                }
                if (painPointsResponse.TenantComplaints === "1") {
                    selectedPainPoints.push("tenantComplaints");
                }
                if (painPointsResponse.TenantChurn === "1") {
                    selectedPainPoints.push("tenantChurn");
                }
                if (painPointsResponse.PoorCustomerSupportfromexistingvendor === "1") {
                    selectedPainPoints.push("poorCustomerSupport");
                }
                if (painPointsResponse.MultipleVendors === "1") {
                    selectedPainPoints.push("multipleVendors");
                }
                if (painPointsResponse.NewBuilding === "1") {
                    selectedPainPoints.push("newBuilding");
                }
                // setSelectPainPoints(selectedPainPoints);

                // Update the state with the full option objects that match the selected values
                setSelectPainPoints(
                    painPointsOptions.filter(option => selectedPainPoints.includes(option.value))
                );


                // Urgent Triggers
                setSelectUrgentTriggers(
                    urgentTriggersOptions.find(option => option.value === data.Response.Data[0].UrgentTriggers)
                );

                // Spectra Relationship
                setSelectSpectraRelationship(
                    spectraRelationshipOptions.find(
                        option => option.value === data.Response.Data[0].SpectraRelationship
                    )
                );
                setSelectRole(roleOptions.find(option => option.value === apiData.Role));
                setSelectContactDesignation(designationOptions.find(option => option.value === apiData.Designation));


                // // Designation2
                // // Role2
                // // Designation3
                // // Role3
                // setSelectPGType({
                //     value: data.Response.Data[0].PGType,
                //     label: data.Response.Data[0].PGType,
                // });
                // setSelectTenantType({
                //     value: data.Response.Data[0].TenantType,
                //     label: data.Response.Data[0].TenantType,
                // });
                // setSelectExistingInternetProvider({
                //     value: data.Response.Data[0].ExistingInternetProvider,
                //     label: data.Response.Data[0].ExistingInternetProvider,
                // });
                // setSelectExistingInternetOutflow({
                //     value: data.Response.Data[0].ExistingInternetOutflowPerMonth,
                //     label: data.Response.Data[0].ExistingInternetOutflowPerMonth,
                // });
                // setSelectCurrentInfra({
                //     value: data.Response.Data[0].CurrentInfra,
                //     label: data.Response.Data[0].CurrentInfra,
                // });
                // setSelectPainPoints({

                //     poorCustomerReviews: data.Response.Data[0].PoorCustomerReviews,
                //     tenantComplaints: data.Response.Data[0].TenantComplaints,
                //     tenantChurn: data.Response.Data[0].TenantChurn,
                //     poorCustomerSupportfromexistingvendor: data.Response.Data[0].PoorCustomerSupportfromexistingvendor,
                //     remark: data.Response.Data[0].MultipleVendors,
                //     remark: data.Response.Data[0].NewBuilding,
                // });
                // setSelectUrgentTriggers({
                //     value: data.Response.Data[0].UrgentTriggers,
                //     label: data.Response.Data[0].UrgentTriggers,
                // });
                // setSelectSpectraRelationship({
                //     value: data.Response.Data[0].SpectraRelationship,
                //     label: data.Response.Data[0].SpectraRelationship,
                // });
                // setSelectRole({
                //     value: data.Response.Data[0].Role,
                //     label: data.Response.Data[0].Role,
                // });


                setSelectDNCno({
                    value: data.Response.Data[0].DncNumber,
                    label: data.Response.Data[0].DncNumber,
                });
                setSelectLeadChannel({
                    value: data.Response.Data[0].Channel,
                    label: data.Response.Data[0].Channel,
                });
                setSelectLeadSource({
                    value: data.Response.Data[0].Source,
                    label: data.Response.Data[0].Source,
                });
                setSelectProductCategory({
                    value: data.Response.Data[0].PlanCategory,
                    label: data.Response.Data[0].PlanCategory,
                });
                setSelectStatusReason({
                    value: data.Response.Data[0].StatusReason,
                    label: data.Response.Data[0].StatusReason,
                });
                setCheckStatusReason(data.Response.Data[0].StatusReason);
                setSelectDisposition({
                    value: data.Response.Data[0].Disposition,
                    label: data.Response.Data[0].Disposition,
                });
                setSelectCompetitorName({
                    value: data.Response.Data[0].CompetitorName,
                    label: data.Response.Data[0].CompetitorName,
                });
                // setSelectCompetitorName({
                //     value: data.Response.Data[0].CompetitorName,
                //     label: data.Response.Data[0].CompetitorName,
                // });
                setSelectIndustrySegment({
                    value: data.Response.Data[0].IndustryTypeId,
                    label: data.Response.Data[0].IndustryTypeId,
                })
                let getdate = data.Response.Data[0].FollowupDate;
                let changeFormatDate = dayjs(getdate, "DD-MM-YYYY HH:mm:ss")
                // console.log("changeFormatDate",changeFormatDate);
                setSelectedDateTime(changeFormatDate);

                const filterState = optionState.find(
                    (item) => item.name === data.Response.Data[0].State
                )?.code;
                // console.log("filterState",filterState)
                setSelectState({
                    value: filterState,
                    label: data.Response.Data[0].State,
                });
                setSelectCity({
                    value: data.Response.Data[0].CityId,
                    label: data.Response.Data[0].City,
                });
                setSelectArea({
                    value: data.Response.Data[0].AreaId,
                    label: `${data.Response.Data[0].Area} (${data.Response.Data[0].AreaId})`,
                });
                setSelectBuilding({
                    value: data.Response.Data[0].BuildingId,
                    label: `${data.Response.Data[0].Building} (${data.Response.Data[0].BuildingId})`,
                });
            } catch (error) {
                //console.error("Error fetching data:", error);
                toast.warning(error, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 500,
                });
                setIsLoading(false);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [ContactId]);


    // console.log("FollowupDate12345 :", userData.numberOfRooms)




    const handleSubmit = async () => {

        if (!userData.firstName) {
            toast.warning("Please Enter First Name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 500,
            });
        } else if (!userData.lastName) {
            toast.warning("Please Enter Last Name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 500,
            });
        } else if (!userData.mobileOne || userData.mobileOne.length < 10) {
            toast.warning("Please Enter Mobile Number", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 500,
            });
        } else if (!selectRole) {
            toast.error("Role must be selected", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!selectContactDesignation) {
            toast.error("Contact Designation must be selected", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });

        }
        // else if (
        //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userData.email)

        // ) {
        //     toast.warning("Please Enter Email Address", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 500,
        //     });
        // } 
        else if (!selectLeadChannel.value) {
            toast.warning("Please Select Lead Channel", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 500,
            });
        } else if (!selectProductCategory.value) {
            toast.warning("Please Select Product Category", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 500,
            });
        } else

            if (!userData.pgName || userData.pgName.trim() === "") {
                toast.error("Name of PG cannot be empty", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
            else

                // Validate select fields
                if (!selectPGType) {
                    toast.error("PG Type must be selected", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                }
                else
                    if (!selectTenantType) {
                        toast.error("Tenant Type must be selected", {
                            position: toast.POSITION.BOTTOM_CENTER,
                            autoClose: 1500,
                        });
                    }
                    else
                        // Validate numeric fields
                        if (!userData.numberOfRooms) {
                            toast.error("Please Enter the Number of Rooms", {
                                position: toast.POSITION.BOTTOM_CENTER,
                                autoClose: 1500,
                            });

                        }
                        else
                            if (!userData.numberOfBeds) {
                                toast.error("Please Enter the Number of Beds", {
                                    position: toast.POSITION.BOTTOM_CENTER,
                                    autoClose: 1500,
                                });
                            }
                            else
                                if (!userData.perBedRent) {
                                    toast.error("Please Enter the Per Bed Rent", {
                                        position: toast.POSITION.BOTTOM_CENTER,
                                        autoClose: 1500,
                                    });
                                }



                                else if (!selectState) {
                                    toast.warning("Please Select State", {
                                        position: toast.POSITION.BOTTOM_CENTER,
                                        autoClose: 500,
                                    });
                                } else if (!selectCity) {
                                    toast.warning("Please  Select City", {
                                        position: toast.POSITION.BOTTOM_CENTER,
                                        autoClose: 500,
                                    });
                                } else if (!selectArea) {
                                    toast.warning("Please  Select Area", {
                                        position: toast.POSITION.BOTTOM_CENTER,
                                        autoClose: 500,
                                    });
                                } else if (!selectBuilding) {
                                    toast.warning("Please  Select Building", {
                                        position: toast.POSITION.BOTTOM_CENTER,
                                        autoClose: 500,
                                    });
                                }
                                else if (!userData?.buildingNoPlotNo) { toast.warning("Building No must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }); }
                                else if (!selectBuildingType?.value) { toast.warning("Building Type must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }); }
                                else if (!userData?.block) { toast.warning("Block must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }); }
                                else if (!userData?.floor) { toast.warning("floor must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }); }
                                else if (!userData?.street) { toast.warning("Street must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }); }
                                else if (!userData?.pinCode) { toast.warning("Pin Code must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }); }

                                else {
                                    if (selectIndustrySegment.value === "PG") {
                                        if (!userData.pgName) {
                                            toast.warning("Please Enter PG Name", {
                                                position: toast.POSITION.BOTTOM_CENTER,
                                                autoClose: 1500,
                                            });

                                        } else {
                                            if (ContactId) {
                                                setIsLoading(true);
                                                let dncNum;
                                                // let reasonStatus;
                                                let dispositionValue;
                                                const contactUpdateUrl = process.env.REACT_APP_API_URL;
                                                if (selectDNCno.value === "Yes") {
                                                    dncNum = "111260001";
                                                } else if (selectDNCno.value === "No") {
                                                    dncNum = "111260000";
                                                }
                                                // if (selectStatusReason.value === "Closed") {
                                                //   reasonStatus = "111260001";
                                                // } else if (
                                                //   selectStatusReason.value === "Scheduled for Appointment"
                                                // ) {
                                                //   reasonStatus = "111260000";
                                                // } else if (selectStatusReason.value === "Lead Created/Closed") {
                                                //   reasonStatus = "111260002";
                                                // }

                                                const statusMap = {
                                                    'Closed': '111260001',
                                                    'Scheduled for Appointment': '111260000',
                                                    'Lead Created/Closed': '111260002'
                                                };
                                                const reasonStatus = statusMap[selectStatusReason.label] || null;

                                                if (selectDisposition.value === "Busy") {
                                                    dispositionValue = "569480000";
                                                } else if (selectDisposition.value === "Call Back") {
                                                    dispositionValue = "569480001";
                                                } else if (selectDisposition.value === "Call Drop") {
                                                    dispositionValue = "569480002";
                                                } else if (selectDisposition.value === "Call To Sales Rep.") {
                                                    dispositionValue = "569480003";
                                                } else if (selectDisposition.value === "Duplicate") {
                                                    dispositionValue = "569480004";
                                                } else if (selectDisposition.value === "Existing Customer") {
                                                    dispositionValue = "569480007";
                                                } else if (selectDisposition.value === "Follow Up") {
                                                    dispositionValue = "569480008";
                                                } else if (selectDisposition.value === "Hung Up") {
                                                    dispositionValue = "569480009";
                                                } else if (selectDisposition.value === "Invalid No.") {
                                                    dispositionValue = "569480010";
                                                } else if (selectDisposition.value === "Landline Issue") {
                                                    dispositionValue = "569480011";
                                                } else if (selectDisposition.value === "Language Barrier") {
                                                    dispositionValue = "569480012";
                                                } else if (selectDisposition.value === "Lead Business") {
                                                    dispositionValue = "569480014";
                                                } else if (selectDisposition.value === "Lead Home") {
                                                    dispositionValue = "569480015";
                                                } else if (selectDisposition.value === "Location is Non RFS") {
                                                    dispositionValue = "569480016";
                                                } else if (selectDisposition.value === "Lost To Competition") {
                                                    dispositionValue = "111260000";
                                                } else if (selectDisposition.value === "No Voice") {
                                                    dispositionValue = "111260001";
                                                } else if (selectDisposition.value === "Not Interested") {
                                                    dispositionValue = "111260002";
                                                } else if (selectDisposition.value === "Not Looking For Services") {
                                                    dispositionValue = "111260003";
                                                } else if (selectDisposition.value === "Not Reachable") {
                                                    dispositionValue = "111260004";
                                                } else if (selectDisposition.value === "Nurture") {
                                                    dispositionValue = "111260005";
                                                } else if (selectDisposition.value === "Online Payment Done") {
                                                    dispositionValue = "111260006";
                                                } else if (selectDisposition.value === "Plan Expensive") {
                                                    dispositionValue = "111260007";
                                                } else if (selectDisposition.value === "Pre Lead Generated") {
                                                    dispositionValue = "111260008";
                                                } else if (selectDisposition.value === "Ringing") {
                                                    dispositionValue = "111260009";
                                                } else if (
                                                    selectDisposition.value === "Service Related Follow up"
                                                ) {
                                                    dispositionValue = "111260010";
                                                } else if (selectDisposition.value === "Switched Off") {
                                                    dispositionValue = "111260011";
                                                } else if (selectDisposition.value === "Test Call") {
                                                    dispositionValue = "111260012";
                                                } else if (selectDisposition.value === "Using Other ISP") {
                                                    dispositionValue = "111260013";
                                                } else if (selectDisposition.value === "Wrong No") {
                                                    dispositionValue = "111260014";
                                                } else if (selectDisposition.value === "SMS Sent") {
                                                    dispositionValue = "111260015";
                                                } else if (selectDisposition.value === "E-Mail Sent") {
                                                    dispositionValue = "111260016";
                                                } else if (selectDisposition.value === "N/A") {
                                                    dispositionValue = "111260017";
                                                }

                                                // const filterState = optionState.find(
                                                //   (state) => state.name === selectState.value
                                                // );
                                                // var originalDate = moment(selectedDateTime, 'DD-MM-YYYYTHH:mm:ss');
                                                // var formattedDate = originalDate.format('MM-DD-YYYY HH:mm:ss');
                                                // console.log("formattedDate",formattedDate);
                                                let finalRemark = userData.remarkHistory || "";

                                                if (userData?.newRemark?.trim()) {
                                                    const userName = sessionStorage.getItem("userName") || "Unknown User";
                                                    const now = new Date();
                                                    const timestamp = now.toLocaleString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    });

                                                    const formattedRemark = `${userName}[${timestamp}]: \n${userData.newRemark}\n`;
                                                    finalRemark = formattedRemark + finalRemark;
                                                }
                                                const contactUpdationData = {
                                                    Action: "updateContactIndustry",
                                                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                                    area: selectArea.value ? selectArea.value : "",
                                                    building: selectBuilding.value ? selectBuilding.value : "",
                                                    BusinessSegment: "Business",
                                                    callAttempted: "1",
                                                    campaignName: userData.campaignName ? userData.campaignName : "",
                                                    channel: selectLeadChannel.value ? selectLeadChannel.value : "",
                                                    city: selectCity.value ? selectCity.value : "",
                                                    competitorName: selectCompetitorName.value
                                                        ? selectCompetitorName.value
                                                        : "",
                                                    ContactId: ContactId ? ContactId : "",
                                                    ContactVerificationStatus: otpContactStatus
                                                        ? otpContactStatus
                                                        : "",
                                                    disposition: selectDisposition.value ? dispositionValue : "",
                                                    dncNumber: selectDNCno.value ? dncNum : "",
                                                    emailAddress: userData.email ? userData.email : "",
                                                    firstName: userData.firstName ? userData.firstName : "",
                                                    followupDate: selectedDateTime ? selectedDateTime : "",
                                                    lastName: userData.lastName ? userData.lastName : "",
                                                    mobileNumber: userData.mobileOne ? userData.mobileOne : "",
                                                    mobileNumber2: userData.contactPerson2Mobile ? userData.contactPerson2Mobile : "",
                                                    password: sessionStorage.getItem("password"),
                                                    planCategory: selectProductCategory.value
                                                        ? selectProductCategory.value
                                                        : "",
                                                    "industryTypeId": "IND_0068_ID",
                                                    ContactPerson2: userData.contactPerson2Name,
                                                    EmailID2: userData.contactPerson2Email,
                                                    Designation2: userData.contactPerson2Designation, // e.g., "111260003"
                                                    DesignationOthers2: userData.designationOthers2,    // Optional: extra text if applicable
                                                    Role2: userData.contactPerson2Role,                 // e.g., "111260001"
                                                    ContactPerson3: userData.contactPerson3Name,
                                                    EmailID3: userData.contactPerson3Email,
                                                    MobileNumber3: userData.contactPerson3Mobile,
                                                    Designation3: userData.contactPerson3Designation,   // e.g., "111260003"
                                                    DesignationOthers3: userData.designationOthers3,      // Optional: extra text if applicable
                                                    Role3: userData.contactPerson3Role,
                                                    PGName: userData.pgName || "",
                                                    PGType: userData.pgType || "",
                                                    // Latitude: position?.latitude ? `${position.latitude}` : "",
                                                    // Longitude: position?.longitude ? `${position.longitude}` : "",
                                                    Latitude: userData?.latitude || `${position.latitude}` || "",
                                                    Longitude: userData?.longitude || `${position.longitude}` || "",


                                                    TenantType: userData.tenantType || "",
                                                    Designation: userData.contactDesignation || "",
                                                    DesignationOthers: userData.contactDesignation === "111260003" ? userData.designationOthers || "" : "", // Only for "Other"
                                                    Role: userData.role || "",
                                                    NumberofRooms: userData.numberOfRooms || "0",
                                                    NumberofBeds: userData.numberOfBeds || "0",
                                                    PerBedRent: userData.perBedRent || "0",
                                                    ExistingInternetProvider: userData.existingInternetProvider || "",
                                                    ExistingInternetProviderOther:
                                                        userData.existingInternetProvider === "111260005" ? userData.existingInternetProviderOther || "" : "", // Only for "Others"
                                                    ExistingInternetOutflowPerMonth: userData.existingInternetOutflow || "",
                                                    ExistingInternetOutflowPerMonthOther:
                                                        userData.existingInternetOutflow === "111260007" ? userData.existingInternetOutflowOther || "" : "", // Only for "Others"
                                                    CurrentInfra: userData.currentInfra || "",
                                                    CurrentInfraOther:
                                                        userData.currentInfra === "111260002" ? userData.currentInfraOther || "" : "", // Only for special condition
                                                    GoogleRatings: userData.googleRatings || "0",
                                                    PGInternetRatings: userData.pgInternetRatings || "0",

                                                    // Pain Points Mapping
                                                    PoorCustomerReviews: userData.painPoints?.includes("poorCustomerReviews") ? "1" : "0",
                                                    TenantComplaints: userData.painPoints?.includes("tenantComplaints") ? "1" : "0",
                                                    TenantChurn: userData.painPoints?.includes("tenantChurn") ? "1" : "0",
                                                    PoorCustomerSupportfromexistingvendor: userData.painPoints?.includes("poorCustomerSupport") ? "1" : "0",
                                                    MultipleVendors: userData.painPoints?.includes("multipleVendors") ? "1" : "0",
                                                    NewBuilding: userData.painPoints?.includes("newBuilding") ? "1" : "0",

                                                    UrgentTriggers: userData.urgentTriggers || "",
                                                    SpectraRelationship: userData.spectraRelationship || "",


                                                    // GoogleRatings: "5",
                                                    // PGInternetRatings: "5",
                                                    remark: finalRemark ? finalRemark : "",
                                                    society: "",
                                                    source: selectLeadSource.value ? selectLeadSource.value : "",
                                                    specifyArea: userData.specificArea ? userData.specificArea : "",
                                                    specifybuilding: userData.specificBuilding
                                                        ? userData.specificBuilding
                                                        : "",
                                                    state: selectState.value ? selectState.value : "",
                                                    statusReason: selectStatusReason.value ? reasonStatus : "",
                                                    "BuildingNoPlotNo": userData?.buildingNoPlotNo,
                                                    "BuildingType": selectBuildingType?.value ? selectBuildingType?.value : "",
                                                    "Block": userData?.block,
                                                    "Floor": userData?.floor,
                                                    "Street": userData?.street,
                                                    "Locality": userData?.locality,
                                                    "LandmarkIfAny": userData?.landmarkIfAny,
                                                    "PinCode": userData?.pinCode,
                                                    userName: sessionStorage.getItem("userName"),
                                                };
                                                try {
                                                    const response = await fetch(contactUpdateUrl, {
                                                        method: "POST",
                                                        headers: {
                                                            "Content-Type": "application/json",
                                                        },
                                                        body: JSON.stringify(contactUpdationData),
                                                    });
                                                    // console.log(
                                                    //   "Request Payload:",
                                                    //   JSON.stringify(contactUpdationData)
                                                    // );
                                                    const data = await response.json();
                                                    const lead = data.Response.ContactId;
                                                    // console.log("API Response contact Update:", data);
                                                    // console.log("response " , data.Response);
                                                    if (data.Status === "Success") {
                                                        if (reasonStatus == "111260002") {
                                                            toast.success("Lead Created Successfully", {
                                                                position: toast.POSITION.BOTTOM_CENTER,
                                                                autoClose: 1500,
                                                            });
                                                            // navigate(`/businessLeadForm?LeadId=${lead}`);
                                                            navigate(`/businessLeadPg`);
                                                        } else {
                                                            toast.success(" Contact updated Successfully", {
                                                                position: toast.POSITION.BOTTOM_CENTER,
                                                                autoClose: 1500,
                                                            });
                                                            navigate("/businessContactPg");
                                                        }
                                                    }
                                                    else {
                                                        setIsLoading(false);
                                                        toast.warning(data.Response.Message, {
                                                            position: toast.POSITION.BOTTOM_CENTER,
                                                            autoClose: 1500,
                                                        });
                                                    }
                                                } catch (error) {
                                                    console.error("Error creating lead:", error);
                                                    toast.error("An error occurred. Please try again later.", {
                                                        position: toast.POSITION.BOTTOM_CENTER,
                                                        autoClose: 1500,
                                                    });
                                                }
                                                finally {
                                                    setIsLoading(false);
                                                }
                                            } else {
                                                let finalRemark = userData.remarkHistory || "";

                                                if (userData.newRemark.trim()) {
                                                    const userName = sessionStorage.getItem("userName") || "Unknown User";
                                                    const now = new Date();
                                                    const timestamp = now.toLocaleString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    });

                                                    const formattedRemark = `${userName}[${timestamp}]: \n${userData.newRemark}\n`;
                                                    finalRemark = formattedRemark + finalRemark;
                                                }
                                                const oldContactCreateUrl = process.env.REACT_APP_API_URL;
                                                const oldContactCreationData = {
                                                    Action: "createContactIndustry",
                                                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                                    area: selectArea.value ? selectArea.value : "",
                                                    building: selectBuilding.value ? selectBuilding.value : "",
                                                    BusinessSegment: "Business",
                                                    callAttempted: "1",
                                                    campaignName: userData.campaignName ? userData.campaignName : "",
                                                    channel: selectLeadChannel.value ? selectLeadChannel.value : "",
                                                    city: selectCity.value ? selectCity.value : "",
                                                    competitorName: selectCompetitorName.value
                                                        ? selectCompetitorName.value
                                                        : "",
                                                    contactId: "",
                                                    contactVerificationStatus: otpContactStatus
                                                        ? otpContactStatus
                                                        : "",
                                                    disposition: selectDisposition.value
                                                        ? selectDisposition.value
                                                        : "",
                                                    dncNumber: selectDNCno.value ? selectDNCno.value : "",
                                                    emailAddress: userData.email ? userData.email : "",
                                                    firstName: userData.firstName ? userData.firstName : "",
                                                    followupDate: selectedDateTime ? selectedDateTime : "",
                                                    lastName: userData.lastName ? userData.lastName : "",
                                                    mobileNumber: userData.mobileOne ? userData.mobileOne : "",
                                                    mobileNumber2: userData.contactPerson2Mobile ? userData.contactPerson2Mobile : "",
                                                    password: sessionStorage.getItem("password"),
                                                    planCategory: selectProductCategory.value
                                                        ? selectProductCategory.value
                                                        : "",
                                                    // PGName: "Testing PG",
                                                    // PGType: "111260000",
                                                    // // lat: position.latitude ? `${position.latitude}` : "",
                                                    // // long: position.longitude ? `${position.longitude}` : "",
                                                    // Latitude: position.latitude ? `${position.latitude}` : "",
                                                    // Longitude: position.longitude ? `${position.longitude}` : "",
                                                    // TenantType: "111260000",
                                                    // Designation: "111260000",
                                                    // DesignationOthers: "",
                                                    // Role: "111260000",
                                                    // NumberofRooms: "10",
                                                    // NumberofBeds: "10",
                                                    // PerBedRent: "15000",
                                                    // GoogleRatings: "5",
                                                    // PGInternetRatings: "5",
                                                    "industryTypeId": "IND_0068_ID",

                                                    "BuildingNoPlotNo": userData?.buildingNoPlotNo,
                                                    "BuildingType": selectBuildingType?.value ? selectBuildingType?.value : "",
                                                    "Block": userData?.block,
                                                    "Floor": userData?.floor,
                                                    "Street": userData?.street,
                                                    "Locality": userData?.locality,
                                                    "LandmarkIfAny": userData?.landmarkIfAny,
                                                    "PinCode": userData?.pinCode,

                                                    ContactPerson2: userData.contactPerson2Name,
                                                    EmailID2: userData.contactPerson2Email,
                                                    Designation2: userData.contactPerson2Designation, // e.g., "111260003"
                                                    DesignationOthers2: userData.designationOthers2,    // Optional: extra text if applicable
                                                    Role2: userData.contactPerson2Role,                 // e.g., "111260001"
                                                    ContactPerson3: userData.contactPerson3Name,
                                                    EmailID3: userData.contactPerson3Email,
                                                    MobileNumber3: userData.contactPerson3Mobile,
                                                    Designation3: userData.contactPerson3Designation,   // e.g., "111260003"
                                                    DesignationOthers3: userData.designationOthers3,      // Optional: extra text if applicable
                                                    Role3: userData.contactPerson3Role,

                                                    PGName: userData.pgName || "",
                                                    PGType: userData.pgType || "",
                                                    // Latitude: position?.latitude ? `${position.latitude}` : "",
                                                    // Longitude: position?.longitude ? `${position.longitude}` : "",
                                                    Latitude: userData?.latitude || `${position.latitude}` || "",
                                                    Longitude: userData?.longitude || `${position.longitude}` || "",
                                                    TenantType: userData.tenantType || "",
                                                    Designation: userData.contactDesignation || "",
                                                    DesignationOthers: userData.contactDesignation === "111260003" ? userData.designationOthers || "" : "", // Only for "Other"
                                                    Role: userData.role || "",
                                                    NumberofRooms: userData.numberOfRooms || "0",
                                                    NumberofBeds: userData.numberOfBeds || "0",
                                                    PerBedRent: userData.perBedRent || "0",
                                                    ExistingInternetProvider: userData.existingInternetProvider || "",
                                                    ExistingInternetProviderOther:
                                                        userData.existingInternetProvider === "111260005" ? userData.existingInternetProviderOther || "" : "", // Only for "Others"
                                                    ExistingInternetOutflowPerMonth: userData.existingInternetOutflow || "",
                                                    ExistingInternetOutflowPerMonthOther:
                                                        userData.existingInternetOutflow === "111260007" ? userData.existingInternetOutflowOther || "" : "", // Only for "Others"
                                                    CurrentInfra: userData.currentInfra || "",
                                                    CurrentInfraOther:
                                                        userData.currentInfra === "111260002" ? userData.currentInfraOther || "" : "", // Only for special condition
                                                    GoogleRatings: userData.googleRatings || "0",
                                                    PGInternetRatings: userData.pgInternetRatings || "0",
                                                    remark: finalRemark ? finalRemark : ""
                                                    // +
                                                    // `PG Info: Created By: ${sessionStorage.getItem(
                                                    //     "userName"
                                                    // )} on ${formattedDateTime} \n` +
                                                    // `Name of the PG: ${userData.pgName} \n` +
                                                    // `PG Owner Name: ${userData.pgOwner} \n` +
                                                    // `PG Contact Number: ${userData.pgContactNum} \n` +
                                                    // `How Many PG's Does this Owner have: ${userData.howManyPg} \n` +
                                                    // `PG Address with landmark: ${userData.pgAddress} \n` +
                                                    // `Area Name: ${userData.pgAreaName} \n` +
                                                    // `Number of Floors in the PG: ${userData.NumOfPgFloor} \n` +
                                                    // `Number of Rooms in the PG: ${userData.NumOfPgRoom} \n` +
                                                    // `Number of Beds in PG: ${userData.NumOfPgBed} \n` +
                                                    // `Current Wifi Operator in the PG: ${userData.currentWifiOperator} \n` +
                                                    // `Number of Broadband connections used: ${userData.NumOfPgBroadband} \n` +
                                                    // `Average Monthly spent on wifi bill: ${selectPgWifiBill.value} \n` +
                                                    // `Date of Recharge of existing connections: ${userData.dateOfRecharge} \n` +
                                                    // `Category of PG: ${selectPgCategory.value} \n` +
                                                    // `CCTV Camera Available in the PG: ${selectPgCamera.value} \n` +
                                                    // `Service Expectations from the Operator: ${userData.serviceExpect} \n` +
                                                    // `Reason to change the current operator: ${userData.changeReason} \n` +
                                                    // `Interested in Spectra PG solution: ${selectPgSolution.value}`
                                                    ,
                                                    society: "",
                                                    source: selectLeadSource.value ? selectLeadSource.value : "",
                                                    specifyArea: userData.specificArea ? userData.specificArea : "",
                                                    specifybuilding: userData.specificBuilding
                                                        ? userData.specificBuilding
                                                        : "",
                                                    state: selectState.value ? selectState.value : "",
                                                    statusReason: selectStatusReason.value
                                                        ? selectStatusReason.value
                                                        : "",
                                                    userName: sessionStorage.getItem("userName"),
                                                };
                                                try {
                                                    setIsLoading(true);
                                                    const response = await fetch(oldContactCreateUrl, {
                                                        method: "POST",
                                                        headers: {
                                                            "Content-Type": "application/json",
                                                        },
                                                        body: JSON.stringify(oldContactCreationData),
                                                    });
                                                    // console.log(
                                                    //   "Request Payload:",
                                                    //   JSON.stringify(oldContactCreationData)
                                                    // );
                                                    const data = await response.json();
                                                    const lead = data.Response.Lead;
                                                    // console.log("API Response contact create:", data);
                                                    // console.log("contact Response", data.Response);
                                                    if (data.Status === "Success") {
                                                        if (selectStatusReason.value == "111260002") {
                                                            toast.success("Lead created Successfully", {
                                                                position: toast.POSITION.BOTTOM_CENTER,
                                                                autoClose: 1500,
                                                            });
                                                            navigate(`/businessLeadPg`);
                                                        } else {
                                                            toast.success("create Contact Successfully", {
                                                                position: toast.POSITION.BOTTOM_CENTER,
                                                                autoClose: 1500,
                                                            });
                                                            navigate("/businessContactPg");
                                                        }
                                                    } else {
                                                        toast.warning(data.Response.Message, {
                                                            position: toast.POSITION.BOTTOM_CENTER,
                                                            autoClose: 1500,
                                                        });
                                                    }
                                                } catch (error) {
                                                    console.error("Error creating lead:", error);
                                                    toast.error("An error occurred. Please try again later.", {
                                                        position: toast.POSITION.BOTTOM_CENTER,
                                                        autoClose: 1500,
                                                    });
                                                }
                                                finally {
                                                    setIsLoading(false);
                                                }
                                            }
                                        }
                                    } else {
                                        if (ContactId) {
                                            setIsLoading(true);
                                            let dncNum;
                                            // let reasonStatus;
                                            let dispositionValue;
                                            const contactUpdateUrl = process.env.REACT_APP_API_URL;
                                            if (selectDNCno.value === "Yes") {
                                                dncNum = "111260001";
                                            } else if (selectDNCno.value === "No") {
                                                dncNum = "111260000";
                                            }
                                            // if (selectStatusReason.value === "Closed") {
                                            //   reasonStatus = "111260001";
                                            // } else if (selectStatusReason.value === "Scheduled for Appointment") {
                                            //   reasonStatus = "111260000";
                                            // } else if (selectStatusReason.value === "Lead Created/Closed") {
                                            //   reasonStatus = "111260002";
                                            // }

                                            const statusMap = {
                                                'Closed': '111260001',
                                                'Scheduled for Appointment': '111260000',
                                                'Lead Created/Closed': '111260002'
                                            };
                                            const reasonStatus = statusMap[selectStatusReason.label] || null;

                                            if (selectDisposition.value === "Busy") {
                                                dispositionValue = "569480000";
                                            } else if (selectDisposition.value === "Call Back") {
                                                dispositionValue = "569480001";
                                            } else if (selectDisposition.value === "Call Drop") {
                                                dispositionValue = "569480002";
                                            } else if (selectDisposition.value === "Call To Sales Rep.") {
                                                dispositionValue = "569480003";
                                            } else if (selectDisposition.value === "Duplicate") {
                                                dispositionValue = "569480004";
                                            } else if (selectDisposition.value === "Existing Customer") {
                                                dispositionValue = "569480007";
                                            } else if (selectDisposition.value === "Follow Up") {
                                                dispositionValue = "569480008";
                                            } else if (selectDisposition.value === "Hung Up") {
                                                dispositionValue = "569480009";
                                            } else if (selectDisposition.value === "Invalid No.") {
                                                dispositionValue = "569480010";
                                            } else if (selectDisposition.value === "Landline Issue") {
                                                dispositionValue = "569480011";
                                            } else if (selectDisposition.value === "Language Barrier") {
                                                dispositionValue = "569480012";
                                            } else if (selectDisposition.value === "Lead Business") {
                                                dispositionValue = "569480014";
                                            } else if (selectDisposition.value === "Lead Home") {
                                                dispositionValue = "569480015";
                                            } else if (selectDisposition.value === "Location is Non RFS") {
                                                dispositionValue = "569480016";
                                            } else if (selectDisposition.value === "Lost To Competition") {
                                                dispositionValue = "111260000";
                                            } else if (selectDisposition.value === "No Voice") {
                                                dispositionValue = "111260001";
                                            } else if (selectDisposition.value === "Not Interested") {
                                                dispositionValue = "111260002";
                                            } else if (selectDisposition.value === "Not Looking For Services") {
                                                dispositionValue = "111260003";
                                            } else if (selectDisposition.value === "Not Reachable") {
                                                dispositionValue = "111260004";
                                            } else if (selectDisposition.value === "Nurture") {
                                                dispositionValue = "111260005";
                                            } else if (selectDisposition.value === "Online Payment Done") {
                                                dispositionValue = "111260006";
                                            } else if (selectDisposition.value === "Plan Expensive") {
                                                dispositionValue = "111260007";
                                            } else if (selectDisposition.value === "Pre Lead Generated") {
                                                dispositionValue = "111260008";
                                            } else if (selectDisposition.value === "Ringing") {
                                                dispositionValue = "111260009";
                                            } else if (selectDisposition.value === "Service Related Follow up") {
                                                dispositionValue = "111260010";
                                            } else if (selectDisposition.value === "Switched Off") {
                                                dispositionValue = "111260011";
                                            } else if (selectDisposition.value === "Test Call") {
                                                dispositionValue = "111260012";
                                            } else if (selectDisposition.value === "Using Other ISP") {
                                                dispositionValue = "111260013";
                                            } else if (selectDisposition.value === "Wrong No") {
                                                dispositionValue = "111260014";
                                            } else if (selectDisposition.value === "SMS Sent") {
                                                dispositionValue = "111260015";
                                            } else if (selectDisposition.value === "E-Mail Sent") {
                                                dispositionValue = "111260016";
                                            } else if (selectDisposition.value === "N/A") {
                                                dispositionValue = "111260017";
                                            }

                                            // const filteredArea = areaList.find(
                                            //   (area) => area.label === selectArea.value
                                            // );
                                            // const selectedAreaValue = filteredArea ? filteredArea.value : "";
                                            // console.log("Selected Area Value:", selectedAreaValue);
                                            // console.log("areaList:", areaList);

                                            // const filteredCity = cityType.find(
                                            //   (city) => city.CityName === selectCity.value
                                            // );
                                            // const selectedCityValue = filteredCity ? filteredCity.CityCode : "";
                                            // console.log("Selected city Value:", selectedCityValue);
                                            // console.log("cityType:", cityType);

                                            // const filterState = optionState.find(
                                            //   (state) => state.name === selectState.value
                                            // );
                                            // console.log("filterState", filterState.code);

                                            const contactUpdationData = {
                                                Action: "updateContactIndustry",
                                                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                                area: selectArea.value ? selectArea.value : "",
                                                building: selectBuilding.value ? selectBuilding.value : "",
                                                BusinessSegment: "Business",
                                                callAttempted: "1",
                                                campaignName: userData.campaignName ? userData.campaignName : "",
                                                channel: selectLeadChannel.value ? selectLeadChannel.value : "",
                                                city: selectCity.value ? selectCity.value : "",
                                                competitorName: selectCompetitorName.value
                                                    ? selectCompetitorName.value
                                                    : "",
                                                ContactId: ContactId ? ContactId : "",
                                                ContactVerificationStatus: otpContactStatus
                                                    ? otpContactStatus
                                                    : "",
                                                disposition: selectDisposition.value ? dispositionValue : "",
                                                dncNumber: selectDNCno.value ? dncNum : "",
                                                emailAddress: userData.email ? userData.email : "",
                                                firstName: userData.firstName ? userData.firstName : "",
                                                followupDate: selectedDateTime ? selectedDateTime : "",
                                                lastName: userData.lastName ? userData.lastName : "",
                                                mobileNumber: userData.mobileOne ? userData.mobileOne : "",
                                                mobileNumber2: userData.contactPerson2Mobile ? userData.contactPerson2Mobile : "",
                                                password: sessionStorage.getItem("password"),
                                                planCategory: selectProductCategory.value
                                                    ? selectProductCategory.value
                                                    : "",
                                                "industryTypeId": "IND_0068_ID",
                                                ContactPerson2: userData.contactPerson2Name,
                                                EmailID2: userData.contactPerson2Email,
                                                Designation2: userData.contactPerson2Designation, // e.g., "111260003"
                                                DesignationOthers2: userData.designationOthers2,    // Optional: extra text if applicable
                                                Role2: userData.contactPerson2Role,                 // e.g., "111260001"
                                                ContactPerson3: userData.contactPerson3Name,
                                                EmailID3: userData.contactPerson3Email,
                                                MobileNumber3: userData.contactPerson3Mobile,
                                                Designation3: userData.contactPerson3Designation,   // e.g., "111260003"
                                                DesignationOthers3: userData.designationOthers3,      // Optional: extra text if applicable
                                                Role3: userData.contactPerson3Role,
                                                PGName: userData.pgName || "",
                                                PGType: userData.pgType || "",
                                                // Latitude: position?.latitude ? `${position.latitude}` : "",
                                                // Longitude: position?.longitude ? `${position.longitude}` : "",
                                                Latitude: userData?.latitude || `${position.latitude}` || "",
                                                Longitude: userData?.longitude || `${position.longitude}` || "",


                                                TenantType: userData.tenantType || "",
                                                Designation: userData.contactDesignation || "",
                                                DesignationOthers: userData.contactDesignation === "111260003" ? userData.designationOthers || "" : "", // Only for "Other"
                                                Role: userData.role || "",
                                                NumberofRooms: userData.numberOfRooms || "0",
                                                NumberofBeds: userData.numberOfBeds || "0",
                                                PerBedRent: userData.perBedRent || "0",
                                                ExistingInternetProvider: userData.existingInternetProvider || "",
                                                ExistingInternetProviderOther:
                                                    userData.existingInternetProvider === "111260005" ? userData.existingInternetProviderOther || "" : "", // Only for "Others"
                                                ExistingInternetOutflowPerMonth: userData.existingInternetOutflow || "",
                                                ExistingInternetOutflowPerMonthOther:
                                                    userData.existingInternetOutflow === "111260007" ? userData.existingInternetOutflowOther || "" : "", // Only for "Others"
                                                CurrentInfra: userData.currentInfra || "",
                                                CurrentInfraOther:
                                                    userData.currentInfra === "111260002" ? userData.currentInfraOther || "" : "", // Only for special condition
                                                GoogleRatings: userData.googleRatings || "0",
                                                PGInternetRatings: userData.pgInternetRatings || "0",

                                                // Pain Points Mapping
                                                PoorCustomerReviews: userData.painPoints?.includes("poorCustomerReviews") ? "1" : "0",
                                                TenantComplaints: userData.painPoints?.includes("tenantComplaints") ? "1" : "0",
                                                TenantChurn: userData.painPoints?.includes("tenantChurn") ? "1" : "0",
                                                PoorCustomerSupportfromexistingvendor: userData.painPoints?.includes("poorCustomerSupport") ? "1" : "0",
                                                MultipleVendors: userData.painPoints?.includes("multipleVendors") ? "1" : "0",
                                                NewBuilding: userData.painPoints?.includes("newBuilding") ? "1" : "0",

                                                UrgentTriggers: userData.urgentTriggers || "",
                                                SpectraRelationship: userData.spectraRelationship || "",


                                                // GoogleRatings: "5",
                                                // PGInternetRatings: "5",
                                                remark:
                                                    userData.remark,
                                                society: "",
                                                source: selectLeadSource.value ? selectLeadSource.value : "",
                                                specifyArea: userData.specificArea ? userData.specificArea : "",
                                                specifybuilding: userData.specificBuilding
                                                    ? userData.specificBuilding
                                                    : "",
                                                state: selectState.value ? selectState.value : "",
                                                statusReason: selectStatusReason.value ? reasonStatus : "",
                                                "BuildingNoPlotNo": userData?.buildingNoPlotNo,
                                                "BuildingType": selectBuildingType?.value ? selectBuildingType?.value : "",
                                                "Block": userData?.block,
                                                "Floor": userData?.floor,
                                                "Street": userData?.street,
                                                "Locality": userData?.locality,
                                                "LandmarkIfAny": userData?.landmarkIfAny,
                                                "PinCode": userData?.pinCode,
                                                userName: sessionStorage.getItem("userName"),
                                            };
                                            try {
                                                setIsLoading(true)
                                                const response = await fetch(contactUpdateUrl, {
                                                    method: "POST",
                                                    headers: {
                                                        "Content-Type": "application/json",
                                                    },
                                                    body: JSON.stringify(contactUpdationData),
                                                });
                                                // console.log(
                                                //   "Request Payload:",
                                                //   JSON.stringify(contactUpdationData)
                                                // );
                                                const data = await response.json();
                                                const lead = data.Response.ContactId;
                                                // console.log("API Response contact Update:", data);
                                                if (data.Status === "Success") {
                                                    if (reasonStatus == "111260002") {
                                                        toast.success(" Lead Created Successfully", {
                                                            position: toast.POSITION.BOTTOM_CENTER,
                                                            autoClose: 1500,
                                                        });
                                                        // navigate(`/businessLeadForm?LeadId=${lead}`);
                                                        navigate(`/businessLeadPg`);
                                                    } else {
                                                        toast.success(" Contact updated Successfully", {
                                                            position: toast.POSITION.BOTTOM_CENTER,
                                                            autoClose: 1500,
                                                        });
                                                        navigate("/businessContactPg");
                                                    }
                                                }
                                                else {
                                                    setIsLoading(false);
                                                    toast.warning(data.Response.Message, {
                                                        position: toast.POSITION.BOTTOM_CENTER,
                                                        autoClose: 1500,
                                                    });
                                                }
                                            } catch (error) {
                                                console.error("Error creating lead:", error);
                                                toast.error("An error occurred. Please try again later.", {
                                                    position: toast.POSITION.BOTTOM_CENTER,
                                                    autoClose: 1500,
                                                });
                                            }
                                            finally {
                                                setIsLoading(false);
                                            }
                                        } else {
                                            const oldContactCreateUrl = process.env.REACT_APP_API_URL;
                                            const oldContactCreationData = {
                                                Action: "createContactIndustry",
                                                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                                area: selectArea.value ? selectArea.value : "",
                                                building: selectBuilding.value ? selectBuilding.value : "",
                                                businessSegment: "Business",
                                                callAttempted: "1",
                                                campaignName: userData.campaignName ? userData.campaignName : "",
                                                channel: selectLeadChannel.value ? selectLeadChannel.value : "",
                                                city: selectCity.value ? selectCity.value : "",
                                                competitorName: selectCompetitorName.value
                                                    ? selectCompetitorName.value
                                                    : "",
                                                contactId: "",
                                                contactVerificationStatus: otpContactStatus ? otpContactStatus : "",
                                                disposition: selectDisposition.value ? selectDisposition.value : "",
                                                dncNumber: selectDNCno.value ? selectDNCno.value : "",
                                                emailAddress: userData.email ? userData.email : "",
                                                firstName: userData.firstName ? userData.firstName : "",
                                                followupDate: selectedDateTime ? selectedDateTime : "",
                                                lastName: userData.lastName ? userData.lastName : "",
                                                mobileNumber: userData.mobileOne ? userData.mobileOne : "",
                                                mobileNumber2: userData.mobileTwo ? userData.mobileTwo : "",
                                                password: sessionStorage.getItem("password"),
                                                planCategory: selectProductCategory.value
                                                    ? selectProductCategory.value
                                                    : "",
                                                remark: userData.remark ? userData.remark : "",
                                                society: "",
                                                source: selectLeadSource?.value ? selectLeadSource?.value : "",
                                                specifyArea: userData.specificArea ? userData.specificArea : "",
                                                specifybuilding: userData.specificBuilding
                                                    ? userData.specificBuilding
                                                    : "",
                                                state: selectState.value ? selectState.value : "",
                                                statusReason: selectStatusReason.value
                                                    ? selectStatusReason.value
                                                    : "",
                                                "BuildingNoPlotNo": userData?.buildingNoPlotNo,
                                                "BuildingType": selectBuildingType?.value ? selectBuildingType?.value : "",
                                                "Block": userData?.block,
                                                "Floor": userData?.floor,
                                                "Street": userData?.street,
                                                "Locality": userData?.locality,
                                                "LandmarkIfAny": userData?.landmarkIfAny,
                                                "PinCode": userData?.pinCode,
                                                userName: sessionStorage.getItem("userName"),
                                            };
                                            try {
                                                setIsLoading(true);
                                                const response = await fetch(oldContactCreateUrl, {
                                                    method: "POST",
                                                    headers: {
                                                        "Content-Type": "application/json",
                                                    },
                                                    body: JSON.stringify(oldContactCreationData),
                                                });
                                                // console.log(
                                                //   "Request Payload :",
                                                //   JSON.stringify(oldContactCreationData)
                                                // );
                                                const data = await response.json();
                                                const lead = data.Response.StatusName;

                                                const text = data.Response.StatusName;
                                                const leadId = text.match(/L-\d{2}-\d{4}-\d{6}/);

                                                if (leadId) {
                                                    // console.log(leadId[0]);  // Output: L-02-2025-281241
                                                }
                                                // console.log("API Response contact create:", data);

                                                // console.log("contact Response", data.Response);
                                                if (data.Status === "Success") {
                                                    if (selectStatusReason.value == "111260002") {
                                                        toast.success("Lead Created Successfully", {
                                                            position: toast.POSITION.BOTTOM_CENTER,
                                                            autoClose: 1500,
                                                        });
                                                        // navigate(`/businessLeadForm?LeadId=${lead}`);
                                                        navigate(`/businessLeadPg`);
                                                    } else {
                                                        toast.success("create Contact Successfully", {
                                                            position: toast.POSITION.BOTTOM_CENTER,
                                                            autoClose: 1500,
                                                        });
                                                        navigate("/businessContactPg");
                                                    }
                                                }
                                                else {
                                                    toast.warning(data.Response.Message, {
                                                        position: toast.POSITION.BOTTOM_CENTER,
                                                        autoClose: 500,
                                                    });
                                                }
                                            } catch (error) {
                                                console.error("Error creating lead:", error);
                                                toast.error("An error occurred. Please try again later.", {
                                                    position: toast.POSITION.BOTTOM_CENTER,
                                                    autoClose: 1500,
                                                });
                                            }
                                            finally {
                                                setIsLoading(false);
                                            }
                                        }
                                    }
                                }
    };

    const handleFlrCreate = () => {
        navigate(`/businessLeadForm?ContactId=${ContactId}`);
    };

    const handleDateTimeChange = (dateTime) => {
        setSelectedDateTime(dateTime);
        // console.log("setSelectedDateTime :",setSelectedDateTime)
    };

    // const handleIconClick = (formId) => {
    //   if (activeForm !== formId) {
    //     setActiveForm(formId);
    //   }
    // };
    const handleIconClick = (formId) => {
        setActiveForm((prevActiveBox) =>
            prevActiveBox === formId ? null : formId
        );
    };

    const navigate = useNavigate();
    const redirectContactManagement = () => {
        Swal.fire({
            html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
            cancelButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                navigate("/businessContactPg");
            } else {
                if (ContactId) {
                    navigate(`/businessPgContactForm?ContactId=${ContactId}`);
                } else {
                    navigate("/businessPgContactForm");
                }
            }
        });
    };

    return (
        <>
            {/* ***********Header********* */}
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectContactManagement}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    {/* <span className="p-1 m-3">Contact Management</span> */}
                    {ContactId ? (
                        <span className="p-1 m-3">Update Contact PG</span>
                    ) : (
                        <span className="p-1 m-3">Contact Management PG</span>
                    )}
                    {/* <span className="flr-createCAf" onClick="">
              FLR/Create CAF
          </span> */}
                    {/* {ContactId && checkStatusReason == "Lead Created/Closed" ? (
            <span className="flr-createCAf" onClick={handleFlrCreate}>
              FLR/Create CAF
            </span>
          ) : null} */}
                </div>
            </div>
            {/* ************Header end************ */}

            <div className="container-fluid form-container">
                {isLoading && (
                    <div className="loader-wrapper">
                        <div className="loader">
                            <img src={loader} alt="loading...."></img>
                        </div>
                    </div>
                )}

                {meetingcounter >= 1 && (
                    <>
                        {(selectStatusReason.value !== "Lead Created/Closed" && selectStatusReason.value !== "Disqualified") &&
                            <div
                            >
                                {!showForm ? (
                                    <button
                                        type="button"
                                        className="btn btn-dark w-100 mt-2 btn text-light"
                                        onClick={() => setShowForm(true)}
                                    >
                                        Disqualify
                                    </button>

                                ) : (
                                    <>
                                        <Select
                                            isMulti
                                            options={optionQualify}
                                            value={selectedReasons}
                                            onChange={handleChanged}
                                            styles={customStyles}
                                            components={{ MultiValueRemove }}
                                            className="basic-multi-select disqualify-select"
                                            classNamePrefix="select"
                                            placeholder="Select Disqualify Reason(s)..."
                                            isSearchable={false}
                                        />
                                        <div className="d-flex justify-content-center gap-2 mt-3 mb-2">
                                            <button
                                                type="button"
                                                className="btn text-light bg-dark rounded-pill submit-btn"
                                                onClick={handleDisqualify}
                                                disabled={!selectedReasons.length}
                                            >
                                                Disqualify
                                            </button>
                                            <button
                                                type="button"
                                                className="btn text-light bg-dark rounded-pill submit-btn"
                                                onClick={() => setShowForm(false)}
                                            >
                                                Cancel
                                            </button>
                                        </div>

                                    </>
                                )}
                            </div>}

                        {selectStatusReason.value === "Contacted" && (
                            <button
                                className="btn w-100 mt-2 qualify-btn text-light"
                                onClick={handleQualify} // Use a separate handler for qualify
                            >
                                Qualify
                            </button>)}

                    </>
                )}


                {/* **************Contact Information toggle******************* */}
                <div
                    className="contact-toggle"
                    onClick={() => handleIconClick("form1")}
                >
                    <span className="toggle-text">Contact Information</span>
                    <span className=" float-end">
                        <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                    </span>
                </div>

                {activeForm === "form1" && (
                    <div
                        className=" container shadow mb-3 bg-body rounded mt-4"
                        id="form1"
                    >
                        {/* *********Contact Information form******** */}
                        <form className=" contact-form p-2">
                            <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    id="fullName"
                                    name="fullName"
                                    value={userData.fullName}
                                    onChange={handleChange}
                                    readOnly={true}
                                    style={{ background: "transparent" }}
                                />
                                <i
                                    className="fa-solid fa-lock text-secondary"
                                    style={{
                                        position: "absolute",
                                        right: "20px",
                                        top: "65%",
                                        transform: "translateY(-50%)",
                                    }}
                                ></i>
                                <label htmlFor="floatingInput" className="m-0">
                                    Full Name
                                </label>
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    id="firstName"
                                    name="firstName"
                                    value={userData.firstName}
                                    onChange={handleChange}
                                    disabled={
                                        ContactId && checkStatusReason == "Lead Created/Closed"
                                    }
                                    style={{ background: "transparent" }}
                                />
                                <label htmlFor="floatingInput" className="mt-2">
                                    First Name*
                                </label>
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    id="lastName"
                                    name="lastName"
                                    value={userData.lastName}
                                    onChange={handleChange}
                                    disabled={
                                        ContactId && checkStatusReason == "Lead Created/Closed"
                                    }
                                    style={{ background: "transparent" }}
                                />
                                <label htmlFor="floatingInput" className="mt-2">
                                    Last Name*
                                </label>
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="tel"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    maxLength="10"
                                    pattern="[0-9]{10}"
                                    id="mobileOne"
                                    name="mobileOne"
                                    disabled={
                                        !fieldsEditable ||
                                        (ContactId && checkStatusReason == "Lead Created/Closed")
                                    }
                                    value={userData.mobileOne}
                                    onChange={handleChange}
                                    style={{ background: "transparent" }}
                                    onKeyDown={(e) => {
                                        const allowedKeys = [
                                            "Backspace",
                                            "Delete",
                                            "ArrowLeft",
                                            "ArrowRight",
                                            "Tab",
                                        ];
                                        const isDigit = /\d/.test(e.key);
                                        if (
                                            (isDigit || allowedKeys.includes(e.key)) &&
                                            (userData.mobileOne.length < 10 || e.key === "Backspace")
                                        ) {
                                            return true;
                                        } else {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                                <label htmlFor="floatingInput" className="mt-2">
                                    Mobile Number*
                                </label>
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="tel"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    id="mobileTwo"
                                    name="mobileTwo"
                                    maxLength="10"
                                    pattern="[0-9]{10}"
                                    disabled={
                                        ContactId && checkStatusReason == "Lead Created/Closed"
                                    }
                                    style={{ background: "transparent" }}
                                    value={userData.mobileTwo}
                                    onChange={handleChange}
                                    onKeyDown={(e) => {
                                        const allowedKeys = [
                                            "Backspace",
                                            "Delete",
                                            "ArrowLeft",
                                            "ArrowRight",
                                            "Tab",
                                        ];
                                        const isDigit = /\d/.test(e.key);
                                        if (
                                            (isDigit || allowedKeys.includes(e.key)) &&
                                            (userData.mobileTwo.length < 10 || e.key === "Backspace")
                                        ) {
                                            return true;
                                        } else {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                                <label htmlFor="floatingInput" className="mt-2">
                                    Mobile Number 2
                                </label>
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    id="email"
                                    name="email"
                                    disabled={
                                        !fieldsEditable ||
                                        (ContactId && checkStatusReason == "Lead Created/Closed")
                                    }
                                    value={userData.email}
                                    onChange={handleChange}
                                    style={{ background: "transparent" }}
                                    onBlur={handleEmailBlur}

                                />
                                <label htmlFor="floatingInput" className="mt-2">
                                    Email ID*
                                </label>
                            </div>
                            <div className="select-container mt-2">
                                <label className="select-search-label">Role*</label>
                                <Select
                                    className="basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    name="role"
                                    placeholder="Select"
                                    styles={style}
                                    value={selectRole}
                                    isSearchable={false}
                                    onChange={handleSelectRole}
                                    options={[
                                        { value: "111260000", label: "KDM" },
                                        { value: "111260001", label: "Influencer" },
                                    ]}
                                />
                            </div>

                            <div className="select-container mt-2">
                                <label className="select-search-label">Contact Designation*</label>
                                <Select
                                    className="basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    name="contactDesignation"
                                    placeholder="Select"
                                    styles={style}
                                    value={selectContactDesignation}
                                    isSearchable={false}
                                    onChange={handleSelectContactDesignation}
                                    options={[
                                        { value: "111260000", label: "Owner" },
                                        { value: "111260001", label: "Manager" },
                                        { value: "111260002", label: "CareTaker" },
                                        { value: "111260003", label: "Other" },
                                    ]}
                                />
                            </div>
                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    id="contactPerson2Name"
                                    name="contactPerson2Name"
                                    value={userData.contactPerson2Name}
                                    onChange={handleChange}
                                    className="form-control input-text form-control-sm mt-1"
                                    placeholder=""
                                />
                                <label htmlFor="contactPerson2Name" className="mt-2">
                                    Contact Person 2 Name
                                </label>
                            </div>

                            <div className="select-container mt-2">
                                <label className="select-search-label">Contact Person 2 Designation</label>
                                <Select
                                    className="basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    name="contactPerson2Designation"
                                    value={selectContact2Designation}
                                    onChange={handleSelectContact2Designation}
                                    styles={style}

                                    options={[
                                        { value: "111260000", label: "Owner" },
                                        { value: "111260001", label: "Manager" },
                                        { value: "111260002", label: "CareTaker" },
                                        { value: "111260003", label: "Other" },
                                    ]}
                                />
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="number"
                                    id="contactPerson2Mobile"
                                    name="contactPerson2Mobile"
                                    value={userData.contactPerson2Mobile}
                                    onChange={handleChange}
                                    className="form-control input-text form-control-sm mt-1"
                                    maxLength="10"
                                    placeholder=""
                                />
                                <label htmlFor="contactPerson2Mobile" className="mt-2">
                                    Contact Person 2 Mobile Number
                                </label>
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    id="contactPerson2Email"
                                    name="contactPerson2Email"
                                    value={userData.contactPerson2Email}
                                    onChange={handleChange}
                                    className="form-control input-text form-control-sm mt-1"
                                    placeholder=""
                                    onBlur={handleEmailBlur}

                                />
                                <label htmlFor="contactPerson2Email" className="mt-2">
                                    Contact Person 2 Email ID
                                </label>
                            </div>

                            <div className="select-container mt-2">
                                <label className="select-search-label">Contact Person 2 Role</label>
                                <Select
                                    className="basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    name="contactPerson2Role"
                                    value={selectContact2Role}
                                    styles={style}

                                    onChange={handleSelectContact2Role}
                                    options={[
                                        { value: "111260000", label: "KDM" },
                                        { value: "111260001", label: "Influencer" },
                                    ]}
                                />
                            </div>
                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    id="contactPerson3Name"
                                    name="contactPerson3Name"
                                    value={userData.contactPerson3Name}
                                    onChange={handleChange}
                                    className="form-control input-text form-control-sm mt-1"
                                    placeholder=""
                                />
                                <label htmlFor="contactPerson3Name" className="mt-2">
                                    Contact Person 3 Name
                                </label>
                            </div>

                            <div className="select-container mt-2">
                                <label className="select-search-label">Contact Person 3 Designation</label>
                                <Select
                                    className="basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    name="contactPerson3Designation"
                                    value={selectContact3Designation}
                                    onChange={handleSelectContact3Designation}
                                    styles={style}

                                    options={[
                                        { value: "111260000", label: "Owner" },
                                        { value: "111260001", label: "Manager" },
                                        { value: "111260002", label: "CareTaker" },
                                        { value: "111260003", label: "Other" },
                                    ]}
                                />
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="number"
                                    id="contactPerson3Mobile"
                                    name="contactPerson3Mobile"
                                    value={userData.contactPerson3Mobile}
                                    onChange={handleChange}
                                    className="form-control input-text form-control-sm mt-1"
                                    maxLength="10"
                                    placeholder=""
                                />
                                <label htmlFor="contactPerson3Mobile" className="mt-2">
                                    Contact Person 3 Mobile Number
                                </label>
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    id="contactPerson3Email"
                                    name="contactPerson3Email"
                                    value={userData.contactPerson3Email}
                                    onChange={handleChange}
                                    className="form-control input-text form-control-sm mt-1"
                                    placeholder=""
                                    onBlur={handleEmailBlur}

                                />
                                <label htmlFor="contactPerson3Email" className="mt-2">
                                    Contact Person 3 Email ID
                                </label>
                            </div>

                            <div className="select-container mt-2">
                                <label className="select-search-label">Contact Person 3 Role</label>
                                <Select
                                    className="basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    name="contactPerson3Role"
                                    styles={style}

                                    value={selectContact3Role}
                                    onChange={handleSelectContact3Role}
                                    options={[
                                        { value: "111260000", label: "KDM" },
                                        { value: "111260001", label: "Influencer" },
                                    ]}
                                />
                            </div>

                            {/* {console.log("selectDNCno :", selectDNCno)} */}
                            {/* <div className="select-container mt-2">
                                <label className="select-search-label ">DNC Number</label>
                                <Select
                                    className=" basic-single form-control form-control-sm  p-1"
                                    classNamePrefix="select"
                                    name="selectDNCno"
                                    placeholder="Select"
                                    styles={style}
                                    value={selectDNCno}
                                    isSearchable={false}
                                    onChange={handleSelectDNC}
                                    isDisabled={
                                        ContactId && checkStatusReason == "Lead Created/Closed"
                                    }
                                    // style={{ background: "transparent" }}
                                    options={optionDncNumber.map((data) => ({
                                        value: data.value,
                                        label: data.label,
                                    }))}
                                />
                            </div> */}

                            {/* {console.log("selectLeadChannel",selectLeadChannel)} */}
                            <div className="select-container mt-2">
                                <label className="select-search-label">Lead Channel*</label>
                                <Select
                                    className=" basic-single form-control form-control-sm  p-1"
                                    classNamePrefix="select"
                                    name="leadChannel"
                                    placeholder="Select"
                                    styles={style}
                                    value={selectLeadChannel}
                                    isSearchable={false}
                                    onChange={handleSelectLead}
                                    isDisabled={
                                        ContactId && checkStatusReason == "Lead Created/Closed"
                                    }
                                    options={optionLeadChannel.map((data) => ({
                                        value: data.value,
                                        label: data.label,
                                    }))}
                                />
                            </div>

                            <div className="">
                                <label className="select-search-label mt-1">Lead Source*</label>
                                <Select
                                    className=" basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    name="leadSource"
                                    placeholder="Select Option"
                                    styles={style}
                                    isSearchable={false}
                                    value={selectLeadSource}
                                    isDisabled={
                                        ContactId && checkStatusReason == "Lead Created/Closed"
                                    }
                                    onChange={handleSelectLeadSource}
                                    options={leadSourceOptions}
                                />
                            </div>
                            {/* 
                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    id="campaignName"
                                    name="campaignName"
                                    value={userData.campaignName}
                                    disabled={
                                        ContactId && checkStatusReason == "Lead Created/Closed"
                                    }
                                    style={{ background: "transparent" }}
                                    onChange={handleChange}
                                />
                                <label htmlFor="floatingInput" className="mt-2">
                                    Campaign Name
                                </label>
                            </div> */}

                            <div className="select-container mt-2">
                                <label className="select-search-label">Product Category*</label>
                                <Select
                                    className=" basic-single form-control form-control-sm  p-1"
                                    classNamePrefix="select"
                                    name="Product"
                                    placeholder="Select"
                                    styles={style}
                                    value={selectProductCategory}
                                    isSearchable={false}
                                    isDisabled={
                                        ContactId && checkStatusReason == "Lead Created/Closed"
                                    }
                                    onChange={handleSelectProductCategory}
                                    options={optionProductCategory.map((data) => ({
                                        value: data.value,
                                        label: data.label,
                                    }))}
                                />
                            </div>

                            {/* {console.log(
                "selectStatusReason.label",
                selectStatusReason
              )} */}
                            <div className="input-box form-floating"
                                style={{ position: "relative", paddingTop: "5px" }}
                            >
                                <input
                                    type="text"
                                    placeholder="latitude"
                                    className="form-control input-text form-control-sm mt-1"
                                    id="latitude"
                                    name="latitude"
                                    disabled
                                    value={userData.latitude || ""}
                                    readOnly={true}
                                    style={{ background: "transparent" }}
                                />
                                <i
                                    className="fa-solid fa-lock text-secondary"
                                    style={{
                                        position: "absolute",
                                        right: "20px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                    }}
                                ></i>
                                <label htmlFor="latitude" className="m-0">Latitude</label>
                            </div>
                            <div className="input-box form-floating"
                                style={{ position: "relative", paddingTop: "5px" }}
                            >
                                <input
                                    type="text"
                                    placeholder="Longitude"
                                    className="form-control input-text form-control-sm mt-1"
                                    id="longitude"
                                    name="longitude"
                                    disabled
                                    value={userData.longitude || ""}
                                    readOnly={true}
                                    style={{ background: "transparent" }}
                                />
                                <i
                                    className="fa-solid fa-lock text-secondary"
                                    style={{
                                        position: "absolute",
                                        right: "20px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                    }}
                                ></i>
                                <label htmlFor="longitude" className="m-0">Longitude</label>
                            </div>




                            {ContactId && (
                                <div className="select-container mt-2">
                                    <label className="select-search-label">Status Reason*</label>
                                    <Select
                                        className=" basic-single form-control form-control-sm  p-1"
                                        classNamePrefix="select"
                                        name="Reason"
                                        placeholder="Select"
                                        styles={style}
                                        value={selectStatusReason}
                                        readonly
                                        isSearchable={false}
                                        onChange={handleSelectStatusReason}
                                        isDisabled
                                        options={optionStatusReason.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />
                                </div>
                            )}
                            

                            {/* dateTime picker calender */}
                            {selectStatusReason.label === "Scheduled for Appointment" && (
                                <div>
                                    <label className="select-search-label mt-1">Follow Up Date/Time</label>
                                    <StyledEngineProvider>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={["MobileDateTimePicker"]}>
                                                <MobileDateTimePicker
                                                    value={selectedDateTime}
                                                    onChange={handleDateTimeChange}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </StyledEngineProvider>
                                </div>)}

                            
                            <div className="select-container mt-2">
                                <label className="select-search-label">Industry Segment*</label>
                                <Select
                                    className=" basic-single form-control form-control-sm  p-1"
                                    classNamePrefix="select"
                                    name="industrySegment"
                                    placeholder="Select"
                                    styles={style}
                                    value={selectIndustrySegment}
                                    isSearchable={false}
                                    onChange={handleSelectIndustrySegment}
                                    options={optionIndustrySegment.map((data) => ({
                                        value: data.value,
                                        label: data.label,
                                    }))}
                                />
                            </div>

                            
                        </form>
                    </div>
                )}

                {/* **************PG Info toggle******************* */}
                {selectIndustrySegment && selectIndustrySegment.value === "PG" ? (
                    <div
                        className="Installation-toggle mt-3"
                        onClick={() => handleIconClick("form2")}
                    >
                        <span className="toggle-text">PG Info</span>
                        <span className=" float-end">
                            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                        </span>
                    </div>
                ) : null}

                {activeForm === "form2" && (
                    <div
                        className=" container shadow mb-3 bg-body rounded mt-4"
                        id="form2"
                    >
                        {/**********PG Info form******** */}
                        <form className="contact-form pg-info-form p-2">
                            {/* PG Details Fields */}
                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className="form-control input-text form-control-sm mt-1"
                                    id="pgName"
                                    name="pgName"
                                    value={userData.pgName}
                                    onChange={handleChange}
                                    style={{ background: "transparent" }}
                                />
                                <label htmlFor="pgName" className="mt-2">Name of PG*</label>
                            </div>

                            <div className="select-container mt-2">
                                <label className="select-search-label">PG Type*</label>
                                <Select
                                    className="basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    name="pgType"
                                    placeholder="Select"
                                    styles={style}
                                    value={selectPGType}
                                    isSearchable={false}
                                    onChange={handleSelectPGType}
                                    options={[
                                        { value: "111260000", label: "Men" },
                                        { value: "111260001", label: "Women" },
                                        { value: "111260002", label: "Hybrid" },
                                    ]}
                                />
                            </div>

                            <div className="select-container mt-2">
                                <label className="select-search-label">Tenant Type*</label>
                                <Select
                                    className="basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    name="tenantType"
                                    placeholder="Select"
                                    styles={style}
                                    value={selectTenantType}
                                    isSearchable={false}
                                    onChange={handleSelectTenantType}
                                    options={[
                                        { value: "111260000", label: "Professional" },
                                        { value: "111260001", label: "Student" },
                                    ]}
                                />
                            </div>
                            {/* Role */}


                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className="form-control input-text form-control-sm mt-1"
                                    id="numberOfRooms"
                                    name="numberOfRooms"
                                    value={userData.numberOfRooms}
                                    onChange={handleChange1}
                                    // onBlur={handleBlur}
                                    style={{ background: "transparent" }}
                                    onKeyDown={(e) => {
                                        const allowedKeys = [
                                            "Backspace",
                                            "Delete",
                                            "ArrowLeft",
                                            "ArrowRight",
                                            "Tab",
                                        ];
                                        const isDigit = /\d/.test(e.key);
                                        if (
                                            (isDigit || allowedKeys.includes(e.key))
                                            //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                        ) {
                                            return true;
                                        } else {
                                            e.preventDefault();
                                        }
                                    }}
                                // max="50"
                                />
                                <label htmlFor="numberOfRooms" className="mt-2">Number of Rooms*</label>
                            </div>

                            {mrafieldone && (
                                <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                    <input
                                        type="text"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-1"
                                        id="DailyRoomRent"
                                        name="DailyRoomRent"
                                        value={userData.NoOfRoomsAsPerMRA}
                                        onChange={handleChange1}
                                        disabled
                                        // onBlur={handleBlur}


                                        style={{ background: "transparent" }}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ];
                                            const isDigit = /\d/.test(e.key);
                                            if (
                                                (isDigit || allowedKeys.includes(e.key))
                                                //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                            ) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}

                                    // max="50"
                                    />
                                    <i
                                        className="fa-solid fa-lock text-secondary"
                                        style={{
                                            position: "absolute",
                                            right: "20px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                        }} 
                                    ></i>
                                    <label htmlFor="DailyRoomRent" className="mt-2">Number of Rooms As Per MRA</label>
                                </div>
                            )}

                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    onKeyDown={(e) => {
                                        const allowedKeys = [
                                            "Backspace",
                                            "Delete",
                                            "ArrowLeft",
                                            "ArrowRight",
                                            "Tab",
                                        ];
                                        const isDigit = /\d/.test(e.key);
                                        if (
                                            (isDigit || allowedKeys.includes(e.key))
                                            //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                        ) {
                                            return true;
                                        } else {
                                            e.preventDefault();
                                        }
                                    }}

                                    placeholder=""
                                    className="form-control input-text form-control-sm mt-1"
                                    id="numberOfBeds"
                                    name="numberOfBeds"
                                    value={userData.numberOfBeds}
                                    onChange={handleChange1}
                                    // onBlur={handleBlur}

                                    style={{ background: "transparent" }}
                                />
                                <label htmlFor="numberOfBeds" className="mt-2">Number of Beds*</label>
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="text"

                                    onKeyDown={(e) => {

                                        const allowedKeys = [

                                            "Backspace",

                                            "Delete",

                                            "ArrowLeft",

                                            "ArrowRight",

                                            "Tab",

                                        ];

                                        const isDigit = /\d/.test(e.key);

                                        if (

                                            (isDigit || allowedKeys.includes(e.key))

                                            //   &&  (basePriceDis < 10 || e.key === "Backspace")

                                        ) {

                                            return true;

                                        } else {

                                            e.preventDefault();

                                        }

                                    }}

                                    placeholder=""
                                    className="form-control input-text form-control-sm mt-1"
                                    id="perBedRent"
                                    name="perBedRent"
                                    value={userData.perBedRent}
                                    onChange={handleChange1}
                                    // onBlur={handleBlur}

                                    style={{ background: "transparent" }}
                                // step="0.01"
                                />
                                <label htmlFor="perBedRent" className="mt-2">Per Bed Rent*</label>

                            </div>

                            {mrafieldtwo && (
                                <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                    <input
                                        type="text"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-1"
                                        id="DailyRoomRent"
                                        name="DailyRoomRent"
                                        value={userData.PerbedrentAsPerMRA}
                                        onChange={handleChange1}
                                        disabled
                                        // onBlur={handleBlur}
                                        style={{ background: "transparent" }}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ];
                                            const isDigit = /\d/.test(e.key);
                                            if (
                                                (isDigit || allowedKeys.includes(e.key))
                                                //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                            ) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                    // max="50"
                                    />
                                    <i
                                        className="fa-solid fa-lock text-secondary"
                                        style={{
                                            position: "absolute",
                                            right: "20px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                        }}
                                    ></i>
                                    <label htmlFor="DailyRoomRent" className="mt-2">Per Bed Rent As Per MRA</label>
                                </div>
                            )}

                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className="form-control input-text form-control-sm mt-1"
                                    id="googleRatings"
                                    name="googleRatings"
                                    value={userData.googleRatings}
                                    onChange={handleChange}
                                    style={{ background: "transparent" }}
                                />
                                <label htmlFor="googleRatings" className="mt-2">Google Ratings</label>
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className="form-control input-text form-control-sm mt-1"
                                    id="pgInternetRatings"
                                    name="pgInternetRatings"
                                    value={userData.pgInternetRatings}
                                    onChange={handleChange}
                                    style={{ background: "transparent" }}
                                />
                                <label htmlFor="pgInternetRatings" className="mt-2">PG Internet Ratings</label>
                            </div>

                            {ContactId && (
                                <>
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="spectraRFS"
                                            name="spectraRFS"
                                            disabled
                                            value={userData.spectraRFS}
                                            onChange={handleChange}
                                            style={{ background: "transparent" }}
                                        />
                                        <label htmlFor="spectraRFS" className="mt-2">Spectra RFS</label>
                                    </div>
                                    {/* Existing Internet Provider */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Existing Internet Provider</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="existingInternetProvider"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectExistingInternetProvider}
                                            isSearchable={false}
                                            onChange={handleSelectExistingInternetProvider}
                                            options={[
                                                { value: "111260000", label: "Airtel" },
                                                { value: "111260001", label: "Jio" },
                                                { value: "111260002", label: "Tata" },
                                                { value: "111260003", label: "ACT" },
                                                { value: "111260004", label: "New Building" },
                                                { value: "111260005", label: "Others" },
                                            ]}
                                        />
                                    </div>

                                    {/* Existing Internet Outflow Per Month */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Existing Internet Outflow Per Month</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="existingInternetOutflow"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectExistingInternetOutflow}
                                            isSearchable={false}
                                            onChange={handleSelectExistingInternetOutflow}
                                            options={[
                                                { value: "111260000", label: "<5000" },
                                                { value: "111260001", label: "5001 - 10000" },
                                                { value: "111260002", label: "10001- 15000" },
                                                { value: "111260003", label: "15001 - 20000" },
                                                { value: "111260004", label: "20001 - 25000" },
                                                { value: "111260005", label: ">25000" },
                                                { value: "111260006", label: "New Building" },
                                                { value: "111260007", label: "Others" },
                                            ]}
                                        />
                                    </div>

                                    {/* Current Infra */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Current Infra</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="currentInfra"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectCurrentInfra}
                                            isSearchable={false}
                                            onChange={handleSelectCurrentInfra}
                                            options={[
                                                // Placeholder options; adjust these based on your requirements.
                                                { value: "111260000", label: "Broadband" },
                                                { value: "111260001", label: "Access Points" },
                                                { value: "111260002", label: "Others" },
                                            ]}
                                        />
                                    </div>

                                    {/* Pain Points - Multi-Select */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Pain Points</label>
                                        <Select
                                            className="basic-multi-select form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="painPoints"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectPainPoints}
                                            isMulti
                                            onChange={handleSelectPainPoints}
                                            options={[
                                                { value: "poorCustomerReviews", label: "Poor Customer Reviews" },
                                                { value: "tenantComplaints", label: "Tenant Complaints" },
                                                { value: "tenantChurn", label: "Tenant Churn" },
                                                { value: "poorCustomerSupport", label: "Poor Customer Support from existing vendor" },
                                                { value: "multipleVendors", label: "Multiple Vendors" },
                                                { value: "newBuilding", label: "New Building" },
                                            ]}
                                        />
                                    </div>

                                    {/* Urgent Triggers */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Urgent Triggers</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="urgentTriggers"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectUrgentTriggers}
                                            isSearchable={false}
                                            onChange={handleSelectUrgentTriggers}
                                            options={[
                                                { value: "111260000", label: "New semester" },
                                                { value: "111260001", label: "Tenant move-ins" },
                                                { value: "111260002", label: "Infrastructure Upgrades" },
                                                { value: "111260003", label: "Expiry of Existing Service Provider" },
                                                { value: "111260004", label: "New Building" },
                                            ]}
                                        />
                                    </div>

                                    {/* Spectra Relationship */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Spectra Relationship</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="spectraRelationship"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectSpectraRelationship}
                                            isSearchable={false}
                                            onChange={handleSelectSpectraRelationship}
                                            options={[
                                                { value: "111260000", label: "Existing User" },
                                                { value: "111260001", label: "Past User" },
                                                { value: "111260002", label: "New" },

                                            ]}
                                        />
                                    </div>


                                </>
                            )}

                        </form>
                    </div>
                )}

                {/* **************Installation Address toggle******************* */}
                <div
                    className="Installation-toggle mt-3"
                    onClick={() => handleIconClick("form3")}
                >
                    <span className="toggle-text">Installation Address</span>
                    <span className=" float-end">
                        <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                    </span>
                </div>

                {activeForm === "form3" && (
                    <div
                        className=" container shadow mb-3 bg-body rounded mt-4"
                        id="form3"
                    >
                        {/**********Installation Address form******** */}
                        <form className="Installation-form p-2">
                            <div className="">
                                <label className="select-search-label mt-1">State*</label>
                                <Select
                                    className=" basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    name="state"
                                    placeholder="Select State"
                                    isSearchable
                                    styles={style}
                                    value={selectState}
                                    onChange={handleSelectState}
                                    isDisabled={
                                        ContactId && checkStatusReason == "Lead Created/Closed"
                                    }
                                    options={optionState.map((data) => ({
                                        value: data.code,
                                        label: data.name,
                                    }))}
                                />
                            </div>

                            {/* {console.log("selectCity", selectCity)} */}
                            <div className="">
                                <label className="select-search-label mt-1">City*</label>
                                <Select
                                    className="basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    name="City"
                                    placeholder="Select City"
                                    isSearchable
                                    isDisabled={
                                        ContactId && checkStatusReason == "Lead Created/Closed"
                                    }
                                    styles={style}
                                    // value={cityType.find((city) => city.CityCode === selectCity.value)}
                                    value={selectCity}
                                    onChange={handleSelectCity}
                                    options={cityType.map((data) => ({
                                        value: data.CityCode,
                                        label: data.CityName,
                                    }))}
                                />
                            </div>

                            <div className="search-area" style={{ position: "relative" }}>
                                <label className="select-search-label mt-1">Area*</label>
                                <Select
                                    options={areaList.map((area) => ({
                                        value: area.AreaCode,
                                        label: `${area.AreaName} (${area.AreaCode})`,
                                    }))}
                                    className="basic-single form-control form-control-sm p-1 custom-select"
                                    placeholder="Search Area"
                                    styles={style}
                                    isSearchable
                                    value={selectArea}
                                    isDisabled={
                                        ContactId && checkStatusReason == "Lead Created/Closed"
                                    }
                                    onChange={handleSelectArea}
                                />
                                <i
                                    className="fas fa-search text-secondary"
                                    style={{
                                        position: "absolute",
                                        right: "15px",
                                        top: "63%",
                                        transform: "translateY(-50%)",
                                    }}
                                ></i>
                            </div>

                            {
                                selectArea &&
                                    selectArea.label.includes("Other") ? (
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="specificArea"
                                            name="specificArea"
                                            value={userData.specificArea}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">
                                            Specific Area Name
                                        </label>
                                    </div>
                                ) : null}

                            <div className="search-building" style={{ position: "relative" }}>
                                <label className="select-search-label mt-1">Building*</label>
                                <Select
                                    options={buildingList.map((building) => ({
                                        value: building.BuildingCode,
                                        label: `${building.BuildingName} (${building.BuildingCode})`,
                                    }))}
                                    className="basic-single form-control form-control-sm p-1 custom-select"
                                    placeholder="Search Building"
                                    styles={style}
                                    isSearchable
                                    value={selectBuilding}
                                    isDisabled={
                                        ContactId && checkStatusReason == "Lead Created/Closed"
                                    }
                                    onChange={(selectedOption) =>
                                        setSelectBuilding(selectedOption)
                                    }
                                />
                                <i
                                    className="fas fa-search text-secondary"
                                    style={{
                                        position: "absolute",
                                        right: "15px",
                                        top: "63%",
                                        transform: "translateY(-50%)",
                                    }}
                                ></i>
                            </div>

                            {
                                selectBuilding &&
                                    selectBuilding.label.includes("Other") ? (
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="specificBuilding"
                                            name="specificBuilding"
                                            value={userData.specificBuilding}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">
                                            Specific Building Name
                                        </label>
                                    </div>
                                ) : null}


                            <div className="">
                                <label className="select-search-label mt-1">Building Type*</label>
                                <Select
                                    className=" basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    name="subBusiness"
                                    placeholder="Select"
                                    styles={style}
                                    value={selectBuildingType}
                                    isSearchable={false}
                                    onChange={handleSelectBuildingType}
                                    options={optionBuildingType.map((data) => ({
                                        value: data.value,
                                        label: data.label,
                                    }))}
                                />
                            </div>


                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    id="buildingNoPlotNo"
                                    name="buildingNoPlotNo"
                                    value={userData.buildingNoPlotNo}
                                    onChange={handleChange}
                                />
                                <label htmlFor="floatingInput" className="mt-2">
                                    Building No./Plot No.*
                                </label>
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    id="block"
                                    name="block"
                                    value={userData.block}
                                    onChange={handleChange}
                                />
                                <label htmlFor="floatingInput" className="mt-2">
                                    Block*
                                </label>
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    id="floor"
                                    name="floor"
                                    value={userData.floor}
                                    onChange={handleChange}
                                />
                                <label htmlFor="floatingInput" className="mt-2">
                                    Floor*
                                </label>
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    id="street"
                                    name="street"
                                    value={userData.street}
                                    onChange={handleChange}
                                />
                                <label htmlFor="floatingInput" className="mt-2">
                                    Street Name*
                                </label>
                            </div>

                            {/* <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    id="locality"
                                    name="locality"
                                    value={userData.locality}
                                    onChange={handleChange}
                                />
                                <label htmlFor="floatingInput" className="mt-2">
                                    Locality*
                                </label>
                            </div> */}

                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    id="landmarkIfAny"
                                    name="landmarkIfAny"
                                    value={userData.landmarkIfAny}
                                    onChange={handleChange}
                                />
                                <label htmlFor="floatingInput" className="mt-2">
                                    Landmark If Any*
                                </label>
                            </div>

                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm mt-1"
                                    id="pinCode"
                                    name="pinCode"
                                    value={userData.pinCode}
                                    onChange={handleChange}
                                    onKeyDown={(e) => {
                                        const allowedKeys = [
                                            "Backspace",
                                            "Delete",
                                            "ArrowLeft",
                                            "ArrowRight",
                                            "Tab",
                                        ];
                                        const isDigit = /\d/.test(e.key);
                                        if (
                                            (isDigit || allowedKeys.includes(e.key)) &&
                                            (userData.pinCode.length < 6 || e.key === "Backspace")
                                        ) {
                                            return true;
                                        } else {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                                <label htmlFor="floatingInput" className="mt-2">
                                    Pin Code*
                                </label>
                            </div>
                        </form>
                    </div>
                )}

                {/* **************Remarks toggle******************* */}
                <div
                    className="Installation-toggle mt-3"
                    onClick={() => handleIconClick("form4")}
                >
                    <span className="toggle-text">Remarks</span>
                    <span className=" float-end">
                        <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                    </span>
                </div>

                {activeForm === "form4" && (
                    <div
                        className=" container shadow  mb-3 bg-body rounded mt-4"
                        id="form4"
                    >
                        <form className="Remark-form p-2">

                            {/* <div className="remark-area">
                                <label htmlFor="floatingInput">Remarks</label>
                                <textarea
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm textarea"
                                    id="remark"
                                    name="remark"
                                    value={userData.remark}
                                    onChange={handleChange}
                                />
                               
                            </div> */}
                            <div className="remark-area">
                                <label htmlFor="newRemark">Add New Remark</label>
                                <textarea
                                    id="newRemark"
                                    name="newRemark"
                                    className="form-control input-text form-control-sm textarea"
                                    placeholder="Write your new remark..."
                                    value={userData.newRemark ?? remarkTemplate}
                                    rows={16} // to make it taller
                                    onChange={(e) =>
                                        setUserData((prev) => ({ ...prev, newRemark: e.target.value }))
                                    }
                                />

                                <label className="mt-3">Previous Remarks (read-only)</label>
                                <textarea
                                    className="form-control input-text form-control-sm textarea"
                                    // value={`Please don't edit old remarks\n\n${userData.remarkHistory}`}
                                    value={`\n${userData.remarkHistory}`}
                                    readOnly
                                />
                            </div>

                        </form>
                    </div>
                )}

                {/* {otpSent ? (
                    otpContactStatus !== "111260000" ? (
                        <div className="row">
                            <div className="col-6">
                                <div className="text-center mt-5">
                                    <button
                                        type="submit"
                                        className="btn text-light bg-dark mx-auto rounded-pill btn-verify_otp"
                                        onClick={() =>
                                            handleResendOtp(userData.email, userData.mobileOne)
                                        }
                                    >
                                        Resend OTP
                                    </button>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="text-center mt-5">
                                    <button
                                        type="submit"
                                        className="btn text-light bg-dark mx-auto rounded-pill btn-resend_otp"
                                        onClick={handleVerifyOtp}
                                    >
                                        Submit OTP
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : null
                ) : (
                    <div className="text-center mt-5 mb-3">
                        <button
                            type="submit"
                            className="btn text-light bg-dark mx-auto rounded-pill submit-btn"
                            onClick={() => handleSendOtp(userData.email, userData.mobileOne)}
                        >
                            Send OTP
                        </button>
                    </div>
                )} */}

                {ContactId && checkStatusReason == "Lead Created/Closed" ? null : (
                    <div className="text-center mt-5 mb-5">
                        <button
                            type="submit"
                            className="btn text-light bg-dark mx-auto rounded-pill submit-btn"
                            onClick={handleSubmit}
                        >
                            Save
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};

export default BusinessPgContactForm;
